import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import * as CryptoJS from 'crypto-js';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var swal: any;
declare var $: any;

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit {


  encryptSecretKey = environment.encryptSecretKey;
  usrDetail = environment.usrDetail;
  // **============================================== Carusole Config================================**
  customOptions: any = {
    // items:1,
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    pagination: false,
    navSpeed: 900,
    // video: true,
    // videoHeight: 300,
    // videoWidth: 600,
    // lazyLoad: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    responsive: {
      0: {
        items: 1
      },
    },
    nav: true
  };
  // **============================================== Carusole Config================================**

  finalData: any;
  apiUrlProgress: any;
  studyId: any;
  token: any;
  prevQuestion: any;
  status: any;
  apiUrlSurvey: any;
  themeUrl: any;
  surveyDetail: any;
  saveSurveyUrl: any;
  rowResponse: any;
  rowList: any;
  arrlength: any;
  opCode: any;
  openEndCheck: any = '';
  respVar: any = {};
  setDataUrl: any;
  setData: any;
  showCard: boolean = false;
  valFinal: any = '';
  openEndLarge: any;
  openEndMedium: any;
  inputData: any;
  projectCreation: FormGroup;
  cookie: any;
  pipeinvariables = {};
  columnLen: any = 0;
  boxLenCarusole: any;
  boxLen: any;
  grid_single_len: any;
  show: any = '';
  finalDropArr = [];
  error_text_to_print: any;
  totalSum: number = 0;
  showErr: boolean = false;
  deskWidth: any;
  apiType: any;
  pre = 0;
  rowLength: any;
  numericMin: any;
  numericMax: any;
  showThankMsg: any;
  showThank: boolean = false;
  showSurvey: boolean = false;
  showError: boolean = false;
  showErrorMsg: any;
  mainDropArr = [];
  responseArr = [];
  identify: any;
  catType: any;
  qidD2: any;
  getBrowser: any;
  videoPlayed = 0;
  totalVideo = [];
  videoCount = {};
  qTextVideo = [];
  masterData = {};
  background: string;
  accent: string;
  font: string;
  backButton: string;
  nextButton: string;
  progressBar: string;
  brandLocation: any;
  attributeData: any;
  attributeSeq: any;
  currentSet: any;
  showPopup: boolean = false;
  selectedImage: any;
  inputTimeout: any;
  crurl: any;
  captchaResponse: string | null = null;
  showCaptcha: boolean = true;
  isDropdownOpen = false;
  selectedOptionDDSC: any = null;
  recordingFormData: any;
  saveRecordingUrl: any
  resetRecordingVar: any
  objectKeys = Object.keys;
  recorderBlob: any = null;
  stopRecordingVar: boolean
  selectedOptionDDSCMap: { [key: string]: any } = {};
  isDropdownOpenMap: { [key: string]: boolean } = {};
  tableMinWidth = '100%'
  showScroll = false;
  showFloatingHeader = false;
  floatingHeaderHtml = '';
  floatingHeaders = [];
  floatingHeaderStyle: any = {};
  topScrollWidth: any
  hideBackButton = false;
  testLink: any

  @ViewChild('scrollTop') scrollTop!: ElementRef;
  @ViewChild('scrollBottom') scrollBottom!: ElementRef;


  dropDual(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  drop(event: CdkDragDrop<string[]>, data) {
    this.show = 'show';
    moveItemInArray(data.rowOptionList, event.previousIndex, event.currentIndex);
  }

  @HostListener('document:click', ['$event']) onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    if (this.surveyDetail?.qType == "text-highlighter" && targetElement && !targetElement.closest("#mobile_highlighter_dropdown") && !targetElement.closest("#mobile_highlighter_dropdown_option")) {
      this.surveyDetail["isSentimentOpen"] = false;
    } else if (this.surveyDetail?.qType == "image-heatmap" && targetElement && !targetElement.closest("#mobile_heatmap_dropdown") && !targetElement.closest("#mobile_heatmap_dropdown_option")) {
      this.surveyDetail["isSentimentOpen"] = false;
    };
  };

  constructor(private formBuilder: FormBuilder, private el: ElementRef, private route: ActivatedRoute, private http: HttpClient, private cdr: ChangeDetectorRef) { }

  // ngOnInit(): void {
  //   const captchaVerified = sessionStorage.getItem('captchaVerified');
  //   if (captchaVerified === 'true') {
  //     this.showCaptcha = false;
  //     this.initialFnCalls();
  //   } else {
  //     this.showCaptcha = true;
  //   }
  // }

  ngOnInit(): void {
    this.showCaptcha = false;
    this.initialFnCalls();
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }


  initialFnCalls() {
    this.crurl = environment.baseUrl;
    // if (environment.production == true) {
    //   this.crurl = environment.baseUrlProd;
    // }
    // else if (environment.development == true) {
    //   this.crurl = environment.baseUrlDev;
    // }
    // else if (environment.staging == true) {
    //   this.crurl = environment.baseUrlStaging;
    // }
    this.finalData = this.route.snapshot.queryParamMap["params"];
    // this.finalData = localStorage.getItem('encodedUrlData');;
    // const decodedUrlData = this.captchaComponent.getDecodedUrlData();
    // if (decodedUrlData) {
    //   this.finalData = decodedUrlData;
    //   console.log("urlData in survey component", this.finalData);
    // }


    this.getBrowser = this.isMobileDevice();

    if (Object.keys(this.finalData).length > 0) {
      this.masterData = this.getSession();
      let stdId = "";
      if (this.masterData != undefined) {
        stdId = this.masterData[this.finalData["zone"]];
        this.pipeinvariables["ID"] = stdId;
      }
      this.studyId = this.finalData["gear"];
      this.token = this.finalData["token"];
      let authData = this.finalData["zone"];
      this.apiType = atob(authData);

      Object.keys(this.finalData).forEach(key => {
        if (key != "token" && key != "gear") {
          this.pipeinvariables[key] = this.finalData[key];
        }
      });

      this.masterData = this.getSession();
      let getID = "";
      if (this.masterData != undefined) {
        getID = this.masterData['_ctl_ID' + this.finalData["gear"]];
        let getProvider = this.masterData['_ctl' + this.finalData["zone"]];
        if (!this.pipeinvariables["ID"] && getID != null && getID != "undefined" && getID != "" && (getProvider == "global" || getProvider == "samplify")) {
          this.pipeinvariables["ID"] = getID;
        }
      }

      if (this.masterData == undefined || this.masterData == null || this.masterData["cookie"] == undefined) {
        if (this.masterData == undefined) {
          this.masterData = {};
        }
        // **============================================== START Progress Api Call================================**
        // **=================================================================================================================**
        this.apiUrlProgress = this.crurl + this.apiType + '/progress/' + this.studyId;
        let sendUrl = btoa(window.location.href);
        let headers = new HttpHeaders({ 'Access-URL': sendUrl });
        this.http.post(this.apiUrlProgress, { "pipe-in": this.pipeinvariables }, { headers }).subscribe(response => {
          if (response["cookie"]) {
            this.cookie = response["cookie"];
            this.masterData["cookie"] = response["cookie"];
            this.setSession(this.masterData);

            this.getSurveyTheme('')
          }

          if (response["test"]) {
            this.testLink = response["test"]
          }

          if (this.pipeinvariables["ID"]) {
            this.masterData[this.pipeinvariables["ID"]] = btoa(this.usrDetail);
            this.setSession(this.masterData);
          }
          if ((response["provider"] == "global" || response["provider"] == "samplify") && response["identification"] == "external" && this.pipeinvariables["ID"] == undefined && (getID == '' || getID == null || getID == "undefined")) {
            this.masterData['_ctl' + this.finalData["zone"]] = response["provider"];
            this.setSession(this.masterData);
            this.callExternal(response["provider"]);
          }
          else {
            if (response["identification"] == "external" && (stdId == null || stdId == "") && response["provider"] == "catalina") {
              this.identify = response;
              this.catType = response["provider"];
              this.masterData['_ctl' + this.finalData["zone"]] = response["provider"];
              delete this.masterData['attempt'];
              this.setSession(this.masterData);
            }
            else if (this.pipeinvariables["ID"]) {
              if (response) {
                if (response["header"]) {
                  if (response["header"]["code"] == 202) {
                    if (response["header"]["redirected"]) {
                      if (response["header"]["redirected"] != '' && response["header"]["redirected"].length > 5) {
                        window.location.href = response["header"]["redirected"];
                      }
                    }
                    else {
                      this.showThankMsg = response["header"]["message"];
                      this.showThank = true;
                      swal({
                        icon: "success",
                        title: response["header"]["message"],
                      });
                    }
                    sessionStorage.clear();
                  }
                  else if (response["header"]["code"] == 401) {
                    if (response["header"]["redirected"]) {
                      if (response["header"]["redirected"] != '' && response["header"]["redirected"].length > 5) {
                        sessionStorage.clear();
                        window.location.href = response["header"]["redirected"];
                      }
                    }
                    else {
                      sessionStorage.clear();
                      swal({
                        buttons: {
                          confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            className: "custom-button-color",
                            closeModal: true
                          },
                        },
                        showCancelButton: false,
                        showConfirmButton: false,
                        title: response["header"]["message"],
                      });
                    }
                  }
                  else if (response["header"]["code"] == 402) {
                    if (response["header"]["redirected"]) {
                      if (response["header"]["redirected"] != '' && response["header"]["redirected"].length > 5) {
                        sessionStorage.clear();
                        window.location.href = response["header"]["redirected"];
                      }
                    }
                    else {
                      sessionStorage.clear();
                      swal({
                        showCancelButton: false,
                        showConfirmButton: false,
                        title: response["header"]["message"],
                        buttons: {
                          confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            className: "custom-button-color",
                            closeModal: true
                          },
                        },
                      });
                    }
                  }
                }
              }
              if (response["cookie"]) {
                this.cookie = response["cookie"];
                if (this.cookie != undefined) {
                  this.fetchApiCall('');
                }
                else {
                  this.initialFnCalls();
                }
              }
            }
          }
        },
          (error) => {
            if (error.status == 500) {
              swal({
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                type: "error",
                text: "Please try after some time",
                title: "There was a problem processing your request"
              });
            }
            if (error.error) {
              if (error.error.header) {
                this.showSurvey = false;
                this.showErrorMsg = error.error.header.message;
                this.showError = true;
              }

              if (error.error.header.code == 404) {
                swal({
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: error.error.header.message,
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                });
              }
              if (error.error.header.code == 401) {
                if (error.error.header.redirected) {
                  if (error.error.header.redirected != '' && error.error.header.redirected.length > 5) {
                    window.location.href = error.error.header.redirected;
                  }
                }
                else {
                  swal({
                    buttons: {
                      confirm: {
                        text: "OK",
                        value: true,
                        visible: true,
                        className: "custom-button-color",
                        closeModal: true
                      },
                    },
                    showCancelButton: false,
                    showConfirmButton: false,
                    title: error.error.header.message,
                  });
                  sessionStorage.clear();
                }
              }
              else if (error.error.header.code == 402) {
                if (error.error.header.redirected) {
                  if (error.error.header.redirected != '' && error.error.header.redirected.length > 5) {
                    window.location.href = error.error.header.redirected;
                  }
                }
                else {
                  swal({
                    showCancelButton: false,
                    showConfirmButton: false,
                    title: error.error.header.message,
                    buttons: {
                      confirm: {
                        text: "OK",
                        value: true,
                        visible: true,
                        className: "custom-button-color",
                        closeModal: true
                      },
                    },
                  });
                  sessionStorage.clear();
                }
              }

              if (error.error.status == 500) {
                swal({
                  icon: environment.errorIcon,
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                  type: "error",
                  text: "Please try after some time",
                  title: "There was a problem processing your request"
                });
              }
              else if (error.error.status == 401) {
                sessionStorage.clear();
                swal({
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: error.error.error.error.header.message,
                });
              }
              else if (error.error.status == 402) {
                swal({
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: error.error.error.error.header.message,
                });
              }
              if (error.status == 400) {
                swal({
                  button: false,
                  text: error.error.header.message,
                  icon: environment.errorIcon,
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                });
              }
            }
          });
      }
      else {
        this.fetchApiCall('');

        this.getSurveyTheme('')
      }

      this.projectCreation = this.formBuilder.group({
        projectpeople: ['', [Validators.required, Validators.pattern("^[1-9]*$")]],
      });

      this.projectCreation.get("projectpeople").valueChanges.subscribe((value) => {
        if (value) {
          this.el.nativeElement.querySelector("#notPrefer").checked = false;
        }
      });
    }
    else {
      this.showSurvey = true;
      this.getSurveyTheme('')
    }
  }

  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }

  onSubmit() {
    if (!this.captchaResponse) {
      alert('Please complete the captcha');
      return;
    } else {
      sessionStorage.setItem('captchaVerified', 'true'); // Mark captcha as verified
      this.showCaptcha = false;
      this.initialFnCalls();
    }
  }

  fetchApiCall(pre) {
    this.recordingFormData = null;
    if (this.cookie == undefined) {
      this.cookie = this.masterData["cookie"];
    }

    if (this.cookie != undefined) {
      // **============================================== START Fetch And Marked Api Call===================================**
      // **=================================================================================================================**
      let sendJson = {};
      this.apiUrlSurvey = this.crurl + this.apiType + '/fetch/' + this.studyId;
      let headers = new HttpHeaders({ 'Authorization-Parameter': this.cookie });
      if (pre != '') {
        sendJson = { "qID": this.prevQuestion, "pipe-in": this.pipeinvariables };
      }
      else {
        sendJson = { "pipe-in": this.pipeinvariables };
      }

      this.http.post(this.apiUrlSurvey, sendJson, { headers, observe: 'response' }).subscribe(response => {
        this.prevQuestion = response.headers.get('prev_question');
        if (response["body"]["SKIP"] == true) {
          this.fetchApiCall('');
        }
        else if (response["body"]["header"]) {
          if (response["body"]["header"]["code"] == 202) {
            if (response["body"]["header"]["redirected"]) {
              if (response["body"]["header"]["redirected"] != '' && response["body"]["header"]["redirected"].length > 5) {
                sessionStorage.clear();
                window.location.href = response["body"]["header"]["redirected"];
              }
            }
            else {
              this.showThankMsg = response["body"]["header"]["message"];
              this.masterData = this.getSession();
              if (this.masterData != undefined) {
                this.catType = this.masterData['_ctl' + this.finalData["zone"]];
              }
              this.showThank = true;
              swal({
                icon: "success",
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                title: response["body"]["header"]["message"],
              });
              sessionStorage.clear();
            }
          }
          else if (response["body"]["header"]["code"] == 401) {
            if (response["body"]["header"]["redirected"]) {
              if (response["body"]["header"]["redirected"] != '' && response["body"]["header"]["redirected"].length > 5) {
                sessionStorage.clear();
                window.location.href = response["body"]["header"]["redirected"];
              }
            }
            else {
              sessionStorage.clear();
              swal({
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                type: "error",
                title: response["body"]["header"]["message"],
              });
            }
          }
          else if (response["body"]["header"]["code"] == 402) {
            if (response["body"]["header"]["redirected"]) {
              if (response["body"]["header"]["redirected"] != '' && response["body"]["header"]["redirected"].length > 5) {
                sessionStorage.clear();
                window.location.href = response["body"]["header"]["redirected"];
              }
            }
            else {
              sessionStorage.clear();
              swal({
                showCancelButton: false,
                showConfirmButton: false,
                title: response["body"]["header"]["message"],
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
              });
            }
          }
        }
        else {
          // this.mainDropArr = [];
          // this.responseArr = [];
          this.surveyDetail = {};
          this.surveyDetail = response["body"];
          // start
          // this.questionA = [];
          // let n = this.surveyDetail.attributeSeq;
          // for (let i = 0; i < this.surveyDetail.attributeSeq.length; i++) {
          //   const element = this.surveyDetail.attributeSeq[i];

          // }
          // end
          if (this.surveyDetail.test_mode == 0) {
            this.hideBackButton = true;
          }
          this.videoPlayed = 0;
          this.qidD2 = this.surveyDetail.qID.toLowerCase();
          this.numericMin = parseInt(this.surveyDetail["MIN-SELECTION"]);
          this.numericMax = parseInt(this.surveyDetail["MAX-SELECTION"]);
          this.rowLength = response["body"]["rowOptionList"].length;
          if (this.surveyDetail["qText2"] != '') {
            this.rowResponse = this.surveyDetail["rowOptionList"];
            this.columnLen = this.surveyDetail["colOptionList"].length;
            if (this.surveyDetail["attributeData"]) {
              this.attributeData = this.surveyDetail["attributeData"][0];
              this.attributeSeq = this.surveyDetail["attributeSeq"].length;
              this.currentSet = this.surveyDetail.attributeSeq[0].set;

            }
            this.showCard = true;
          }
          else {
            this.rowResponse = this.surveyDetail["rowOptionList"];
            this.columnLen = this.surveyDetail["colOptionList"].length;
            if (this.surveyDetail["attributeData"]) {
              this.attributeData = this.surveyDetail["attributeData"][0];
              this.attributeSeq = this.surveyDetail["attributeSeq"].length;
              this.currentSet = this.surveyDetail.attributeSeq[0].set;
            }
            this.showCard = true;
          }

          if (this.surveyDetail.qType == 'recode-single') {
            this.surveyDetail.qType = 'single-select'
          }
          if (this.surveyDetail.qType == 'recode-multi') {
            this.surveyDetail.qType = 'multiple-select'
          }

          if (this.surveyDetail.qType == 'max-diff') {
            this.surveyDetail.attributeSeq.forEach((element, i) => {
              let x = { 'maxW': null, 'maxB': null }
              this.surveyDetail.attributeSeq[i] = { ...element, ...{ values: x } }
            });
          }
          this.surveyDetail.qText2.forEach(v1 => {
            if (v1.type == "video") {
              this.totalVideo.push(v1);
              this.qTextVideo.push(v1);
              // v1.detail = atob(v1.detail);
              this.masterData = this.getSession();
              if (this.masterData != undefined) {
                let videoId = v1.id.substring(0, v1.id.length - 2);
                let videoStatus = this.masterData[this.pipeinvariables["ID"] + videoId];
                if (videoStatus != null && videoStatus == videoId) {
                  this.videoPlayed = 1;
                }
              }
            }
            if (v1.type == "image") {
              // v1.detail = atob(v1.detail);
            }
          });

          this.surveyDetail.qText.forEach(v2 => {
            if (v2.type == "video") {
              this.totalVideo.push(v2);
              this.qTextVideo.push(v2);
              // v2.detail = atob(v2.detail);
              this.masterData = this.getSession();

              if (this.masterData != undefined) {
                let videoId = v2.id.substring(0, v2.id.length - 2);
                let videoStatus = this.masterData[this.pipeinvariables["ID"] + videoId];
                if (videoStatus != null && videoStatus == videoId) {
                  this.videoPlayed = 1;
                }
              }
            }
            if (v2.type == "image") {
              // v2.detail = atob(v2.detail);
            }
          });

          // Make rowoption & col option encode
          this.surveyDetail["rowOptionList"].forEach(rowop => {
            if (rowop.hasVideo == 1) {
              rowop.optionText.forEach(op => {
                if (op.type == "video") {
                  this.totalVideo.push(op);
                  // op.detail = atob(op.detail);
                  this.masterData = this.getSession();
                  if (this.masterData != undefined) {
                    let videoId = op.id.substring(0, op.id.length - 2);
                    let videoStatus = this.masterData[this.pipeinvariables["ID"] + videoId];
                    if (videoStatus != null && videoStatus == videoId) {
                      this.videoPlayed = 1;
                    }
                  }
                }
              });
            }
          });

          this.surveyDetail["colOptionList"].forEach(colOp => {
            if (colOp.hasVideo == 1) {
              colOp.optionText.forEach(opcol => {
                if (opcol.type == "video") {
                  this.totalVideo.push(opcol);
                  // opcol.detail = atob(opcol.detail);
                  this.masterData = this.getSession();
                  if (this.masterData != undefined) {
                    let videoId = opcol.id.substring(0, opcol.id.length - 2);
                    let videoStatus = this.masterData[this.pipeinvariables["ID"] + videoId];
                    if (videoStatus != null && videoStatus == videoId) {
                      this.videoPlayed = 1;
                    }
                  }
                }
              });
            }
          });

          this.boxLen = (780 / this.columnLen);
          // this.boxLen = this.columnLen > 8 ? (780 / 8) : (780 / this.columnLen);

          this.boxLenCarusole = (90 / this.rowResponse.length);
          this.rowList = this.rowResponse.length;
          // this.grid_single_len = (90 / this.columnLen);
          if (this.columnLen > 10) {
            this.showScroll = true;
            this.grid_single_len = 78;
            this.tableMinWidth = `${(this.columnLen * this.grid_single_len)}px`;
            this.topScrollWidth = `${(this.columnLen * this.grid_single_len) + 150}px`;
          } else {
            this.showScroll = false;
            this.grid_single_len = 100 / this.columnLen;
            this.tableMinWidth = '100%';
          }
          if (this.isGridTableQType(this.surveyDetail.qType)) {
            // Phantom-scrollbar fix + word-safe dynamic width, scoped to grid table qTypes only.
            if (this.columnLen <= 10) {
              this.topScrollWidth = '100%';
            }
            // Recompute once the grid has actually rendered so we can measure the real
            // container width and each column's longest heading word, and only fall back
            // to horizontal scroll if a single word genuinely doesn't fit — multi-word
            // headers are allowed to wrap onto a new line first to try to avoid the scroll.
            // Poppins is loaded from Google Fonts (see index.html), so it may not have
            // finished downloading yet on first render — measuring text width before it's
            // ready silently falls back to a generic system font, which can under/over-
            // estimate word widths and trigger scroll on a table that actually fits fine.
            // Wait for the real font before measuring.
            const recomputeGridSizing = () => this.updateGridColumnSizing();
            if (typeof document !== 'undefined' && (document as any).fonts && (document as any).fonts.ready) {
              (document as any).fonts.ready.then(() => setTimeout(recomputeGridSizing, 0));
            } else {
              setTimeout(recomputeGridSizing, 0);
            }
          }
          if (this.surveyDetail.qType == "drag-n-drop-ranking-column") {
            this.mainDropArr = [];
            this.surveyDetail["rowOptionList"].forEach(drop => {
              this.mainDropArr.push(drop);
            });
          }
          if (this.surveyDetail.qType?.toLowerCase() == "text-highlighter") {
            this.makeTextHighlighter();
          };

          if (this.surveyDetail.qType == "image-heatmap") {
            this.makeImageHeatmap();
          };

          // if (this.surveyDetail.test_mode == 1) {
          this.getMarkedApi();
          // }
          // Added to fix recording button which is showing in test but not in live
          // else {
          if (this.surveyDetail.test_mode != 1) {
            setTimeout(() => {
              if (this.rowList == 1 && (this.surveyDetail.qType == "single-select" || this.surveyDetail.qType == "sum-upto-n" || this.surveyDetail.qType == "multiple-select")) {
                this.saveSurvey();
              }
            }, 300);
          }
          // }
        }
      },
        (error) => {
          if (error.status == 500) {
            swal({
              icon: environment.errorIcon,
              buttons: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  className: "custom-button-color",
                  closeModal: true
                },
              },
              type: "error",
              text: "Please try after some time",
              title: "There was a problem processing your request"
            });
          }

          if (error.error) {
            if (error.error.header.code == 404) {
              swal({
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                type: "error",
                showCancelButton: false,
                showConfirmButton: false,
                title: error.error.header.message,
              });
            }

            if (error.error.header.code == 401) {
              if (error.error.header.redirected) {
                if (error.error.header.redirected != '' && error.error.header.redirected.length > 5) {
                  window.location.href = error.error.header.redirected;
                }
                else {
                  this.showSurvey = false;
                  this.showErrorMsg = error.error.header.message;
                  this.showError = true;
                }
              }
              else {
                this.showSurvey = false;
                this.showErrorMsg = error.error.header.message;
                this.showError = true;
                swal({
                  icon: environment.errorIcon,
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                  type: "error",
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: error.error.header.message,
                });
                sessionStorage.clear();
              }
            }
            if (error.status == 401) {
              swal({
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                type: "error",
                text: error.error.header.message,
              });
              // swal(error.error.header.message, "", "error");
            }

            if (error.status == 400) {
              swal({
                button: false,
                text: error.error.header.message,
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
              });
            }
          }
        });
      // **============================================== END Fetch And Marked Api Call===================================**
      // **=================================================================================================================**
    }
    else {
      this.initialFnCalls();
    }
  }

  getMarkedApi() {
    this.setDataUrl = this.crurl + this.apiType + '/marked/' + this.studyId;
    let headers = new HttpHeaders({ 'Authorization-Parameter': this.cookie });
    this.http.post(this.setDataUrl, { "pipe-in": this.pipeinvariables }, { headers }).subscribe(response => {
      this.setData = response;
      if (this.rowList == 1 && this.pre == 0 && (this.surveyDetail.qType == "single-select" || this.surveyDetail.qType == "sum-upto-n" || this.surveyDetail.qType == "multiple-select")) {
        this.saveSurvey();
      }
      this.finalDropArr = [];
      if (this.surveyDetail.qType == "open-end-small" && this.rowList == 0) {
        if (this.setData[this.surveyDetail.var]) {
          this.el.nativeElement.querySelector("#dataVal").value = this.setData[this.surveyDetail.var];
          if (this.totalVideo.length > 0 && this.setData[this.surveyDetail.var]) {
            this.videoPlayed = 1;
          }
        }
      }
      else if (this.surveyDetail.qType == "open-end-small" && this.rowList > 0) {
        this.surveyDetail.rowOptionList.forEach((data, a) => {
          if (this.totalVideo.length > 0 && this.setData[this.rowResponse[a].var]) {
            this.videoPlayed = 1;
          }
          if (this.rowResponse[a].optionType == "open-end-small" && this.setData[this.rowResponse[a].var] != '' && this.setData[this.rowResponse[a].var] != null) {
            this.projectCreation.get("projectpeople").patchValue(this.setData[this.rowResponse[a].var]);
            this.respVar[this.rowResponse[a].var] = this.setData[this.rowResponse[a].var];
          } else if (this.rowResponse[a].exclusive == 1 && this.setData[this.rowResponse[a].var] != '' && this.setData[this.rowResponse[a].var] != null) {
            this.el.nativeElement.querySelector('#notPrefer').checked = true;
            this.respVar[this.rowResponse[a].var] = 1;
          }
        });
      }
      else if (this.surveyDetail.qType == "open-end-large" && this.rowList == 0) {
        if (this.setData[this.surveyDetail.var]) {
          this.el.nativeElement.querySelector("#opLarge").value = this.setData[this.surveyDetail.var];
        }
        if (this.totalVideo.length > 0 && this.setData[this.surveyDetail.var]) {
          this.videoPlayed = 1;
        }
      }
      else if (this.surveyDetail.qType == "open-end-large" && this.rowList > 0) {
        this.rowResponse.forEach(ele => {
          if (this.totalVideo.length > 0 && this.setData[ele.var]) {
            this.videoPlayed = 1;
          }
          if (ele.optionType == "open-end-large") {
            if (this.setData[ele.var]) {
              this.el.nativeElement.querySelector("#opLarge").value = this.setData[ele.var];
            }
          }
          else if (ele.optionType == "single-select") {
            if (this.setData[ele.var] == 1) {
              this.el.nativeElement.querySelector("#op_end_lg").checked = true;
            } else if (this.setData[ele.var] == 0) {
              this.el.nativeElement.querySelector("#op_end_lg").checked = false;
            }
          }
        });
      }
      else if (this.surveyDetail.qType == "open-end-medium" && this.rowList == 0) {
        if (this.setData[this.surveyDetail.var]) {
          this.el.nativeElement.querySelector("#openEndMedium").value = this.setData[this.surveyDetail.var];
        }
        if (this.totalVideo.length > 0 && this.setData[this.surveyDetail.var]) {
          this.videoPlayed = 1;
        }
      }
      else if (this.surveyDetail.qType == "open-end-medium" && this.rowList > 0) {
        this.rowResponse.forEach(ele => {
          if (this.totalVideo.length > 0 && this.setData[ele.var]) {
            this.videoPlayed = 1;
          }
          if (ele.optionType == "open-end-medium") {
            if (this.setData[ele.var]) {
              this.el.nativeElement.querySelector("#openEndMedium").value = this.setData[ele.var];
            }
          }
          else if (ele.optionType == "single-select") {
            if (this.setData[ele.var] == 1) {
              this.el.nativeElement.querySelector("#op_end_md").checked = true;
            }
            else if (this.setData[ele.var] == 0) {
              this.el.nativeElement.querySelector("#op_end_md").checked = false;
            }
          }
        });
      }
      else if (this.surveyDetail.qType == "single-select") {
        if (this.rowList > 0) {
          this.surveyDetail.rowOptionList.forEach((data, a) => {
            if (this.setData[this.surveyDetail.var] == this.rowResponse[a].optionCode) {
              this.el.nativeElement.querySelector('#sin' + a).checked = true;
              if (this.setData[this.surveyDetail.var + "_" + this.rowResponse[a].optionCode + "_other"]) {
                let mkId = this.surveyDetail.var + "_" + this.rowResponse[a].optionCode + "_other";
                this.valFinal = this.setData[mkId];
                this.el.nativeElement.querySelector(".othSin" + this.surveyDetail.var + this.rowResponse[a].optionCode).value = this.valFinal;
              }
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "multiple-select") {
        if (this.rowList > 0) {
          this.surveyDetail.rowOptionList.forEach((data, a) => {
            if (this.setData[this.rowResponse[a].var] == 1) {
              this.el.nativeElement.querySelector('#list' + a).checked = true;
            }
            if (this.rowResponse[a].default == 1) {
              this.el.nativeElement.querySelector('#list' + a).disabled = true;
            }
            if (this.setData[this.rowResponse[a].var + "_other"]) {
              this.el.nativeElement.querySelector('#list' + a).checked = true;
              this.el.nativeElement.querySelector(".oth" + this.rowResponse[a].var).value = this.setData[this.rowResponse[a].var + "_other"];
            }

            if (this.totalVideo.length > 0 && this.setData[this.rowResponse[a].var] == 1 || this.setData[this.rowResponse[a].var + "_other"]) {
              this.videoPlayed = 1;
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "grid-row-single-select-carousel") {
        if (this.rowList > 0) {
          let countSuccess = 0;
          let widthScreen = window.innerWidth;
          if (widthScreen > 768) {
            this.surveyDetail.rowOptionList.forEach((data, a) => {
              this.surveyDetail.colOptionList.forEach((col, z) => {
                let mkIdData = this.setData[this.rowResponse[a].var];
                if (mkIdData == this.surveyDetail.colOptionList[z].optionCode) {
                  let mkdId = '#cl' + this.surveyDetail.colOptionList[z].optionCode + a;
                  this.el.nativeElement.querySelector(mkdId).checked = true;
                  countSuccess += 1;
                }
              });
            });

            if (countSuccess == this.rowList) {
              this.arrlength = this.rowList;
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
                let getAll = this.el.nativeElement.querySelectorAll(".p-none");
                getAll.forEach(ele => {
                  ele.classList.remove("p-none");
                });
              }
              if (this.rowList > 1) {
                let rmAll = this.el.nativeElement.querySelectorAll(".carousel-control-next");
                rmAll.forEach(rm => {
                  rm.classList.remove("d-none");
                });
              }
            }
          } else {
            let countSuccessMob = 0;
            this.surveyDetail.rowOptionList.forEach((data, a) => {
              this.surveyDetail.colOptionList.forEach((col, z) => {
                let mkIdDataMob = this.setData[this.rowResponse[a].var];
                if (mkIdDataMob == this.surveyDetail.colOptionList[z].optionCode) {
                  let mkdIdMOb = '#clTr' + this.surveyDetail.colOptionList[z].optionCode + a;
                  this.el.nativeElement.querySelector(mkdIdMOb).checked = true;
                  countSuccessMob += 1;
                }
              });
            });

            if (countSuccessMob == this.rowList) {
              this.arrlength = this.rowList;
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
                let rmAll = this.el.nativeElement.querySelectorAll(".carousel-control-next");
                rmAll.forEach(rm => {
                  rm.classList.remove("d-none");
                });
                let getAll = this.el.nativeElement.querySelectorAll(".p-none");
                getAll.forEach(ele => {
                  ele.classList.remove("p-none");
                });
              }
            }
          }
        }
      }
      else if (this.surveyDetail.qType == "grid-row-single-select") {
        if (this.rowList > 0) {
          this.rowResponse.forEach((element, z) => {
            let variable = this.rowResponse[z].var;
            let variableResponse = this.setData[variable];
            if (variableResponse) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              let mkdIdQ2 = '#rwgrd' + variable + '_' + (variableResponse - 1);
              this.el.nativeElement.querySelector(mkdIdQ2).checked = true;
              this.el.nativeElement.querySelector("#" + element.var + "_opCode").value = variableResponse;
            }
          });

          this.rowResponse.forEach(rowm => {
            if (rowm.other == 1 && this.setData[rowm.var + "_other"]) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              this.el.nativeElement.querySelector("#" + rowm.var + "_other").value = this.setData[rowm.var + "_other"];
              this.el.nativeElement.querySelector("#" + rowm.var + "_otherMob").value = this.setData[rowm.var + "_other"];
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "grid-column-single-select" && (this.surveyDetail.qID == 'q2' || this.surveyDetail.qID == 'Q2')) {
        if (this.rowList > 0) {
          this.surveyDetail.colOptionList.forEach((col, z) => {
            let variable = this.surveyDetail.colOptionList[z].var;
            let variableResponse = this.setData[variable];
            if (variableResponse) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              let mkdIdQ2 = '#rw' + variable + '_' + (variableResponse);
              this.el.nativeElement.querySelector(mkdIdQ2).checked = true;
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "grid-column-single-select" && this.surveyDetail.qID != 'q2' && this.surveyDetail.qID != 'Q2') {
        if (this.rowList > 0) {
          this.surveyDetail["colOptionList"].forEach(col => {
            if (this.setData[col.var]) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              let mkdIdQ2 = '#rwCol' + col.var + '_' + (this.setData[col.var]);
              this.el.nativeElement.querySelector(mkdIdQ2).checked = true;
              this.el.nativeElement.querySelector("#" + col.var + "_opCode_col").value = this.setData[col.var];
            }
          });

          this.surveyDetail["colOptionList"].forEach(colm => {
            if (colm.other == 1 && this.setData[colm.var + "_other"]) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              this.el.nativeElement.querySelector("#" + colm.var + "_other").value = this.setData[colm.var + "_other"];
              this.el.nativeElement.querySelector("#" + colm.var + "_otherMob_col").value = this.setData[colm.var + "_other"];
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "grid-row-multiple-select") {
        if (Object.keys(this.setData).length != 0) {
          Object.keys(this.setData).forEach(data => {
            let value = this.setData[data];
            if (value == 1) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              if (this.getBrowser == true) {
                this.el.nativeElement.querySelector("#mob_" + data).checked = true;
              } else {
                this.el.nativeElement.querySelector("#" + data).checked = true;
              }
            }
          });

          this.rowResponse.forEach(rowm => {
            if (rowm.other == 1 && this.setData[rowm.var + "_other"]) {
              if (this.getBrowser == true) {
                this.el.nativeElement.querySelector("#" + rowm.var + "_other_mob").value = this.setData[rowm.var + "_other"];
              } else {
                this.el.nativeElement.querySelector("#" + rowm.var + "_other").value = this.setData[rowm.var + "_other"];
              }
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "grid-column-multiple-select") {
        if (Object.keys(this.setData).length != 0) {
          Object.keys(this.setData).forEach(parms => {
            let dataVal = this.setData[parms];
            if (dataVal == 1) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
              if (this.getBrowser == true) {
                this.el.nativeElement.querySelector("#mob_col_" + parms).checked = true;
              } else {
                this.el.nativeElement.querySelector("#" + parms).checked = true;
              }
            }
          });

          this.surveyDetail["colOptionList"].forEach(colm => {
            if (colm.other == 1 && this.setData[colm.var + "_other"]) {
              if (this.getBrowser == true) {
                this.el.nativeElement.querySelector("#" + colm.var + "_other_mob").value = this.setData[colm.var + "_other"];
              } else {
                this.el.nativeElement.querySelector("#" + colm.var + "_other").value = this.setData[colm.var + "_other"];
              }

            }
          });
        }
      }
      else if (this.surveyDetail.qType == "ranking") {
        if (this.rowList > 0) {
          this.rowResponse.forEach(rankCol => {
            if (rankCol.exclusive == 0) {
              if (rankCol.other == 1 && this.setData[rankCol.var + "_other"]) {
                this.el.nativeElement.querySelector('#' + rankCol.var + "_other").value = this.setData[rankCol.var + "_other"];
                this.el.nativeElement.querySelector('#' + rankCol.var).value = this.setData[rankCol.var];
              } else if (rankCol.other == 0 && this.setData[rankCol.var]) {
                this.el.nativeElement.querySelector('#' + rankCol.var).value = this.setData[rankCol.var];
              }
            } else {
              if (this.setData[rankCol.var] == 1 && rankCol.exclusive == 1) {
                this.el.nativeElement.querySelector('#rank_' + rankCol.var).checked = true;
              }
            }
            if (this.setData[rankCol.var]) {
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "sum-upto-n") {
        if (this.rowList > 0) {
          let fialTotal = 0;
          this.rowResponse.forEach((row, i) => {
            if (row.exclusive == 0) {
              if (this.setData[row.var] != null && this.setData[row.var]) {
                this.el.nativeElement.querySelector('#sumUp' + row.var).value = this.setData[row.var];
                fialTotal += parseInt(this.setData[row.var]);
                this.el.nativeElement.querySelector("#totalData").value = fialTotal;
              }
              if (this.setData[row.var + "_other"] && row.other == 1) {
                this.el.nativeElement.querySelector("#" + row.var + "_other").value = this.setData[row.var + "_other"];
              }
            } else {
              if (this.setData[row.var] > 0) {
                this.el.nativeElement.querySelector("#list_" + row.var).checked = true;
              }
              if (this.setData[row.var + "_other"] && row.other == 1) {
                this.el.nativeElement.querySelector("#" + row.var + "_other").value = this.setData[row.var + "_other"];
              }
            }
          });

          if (fialTotal > 0 && this.totalVideo.length > 0) {
            this.videoPlayed = 1;
          }
        }
      }
      else if (this.surveyDetail.qType == "drag-n-drop-ranking") {
        if (this.rowList > 0) {
          this.surveyDetail.rowOptionList.forEach((col, a) => {
            this.setData[this.rowResponse[a].var];
            if (this.setData[this.rowResponse[a].var] != null && this.setData[this.rowResponse[a].var] != '') {
              let json = {
                "optionText": this.rowResponse[a].optionText,
                "optionVal": this.setData[this.rowResponse[a].var],
                "var": this.rowResponse[a].var,
              }
              this.finalDropArr.push(json);
              this.show = 'set';
              if (this.totalVideo.length > 0) {
                this.videoPlayed = 1;
              }
            }
            else {
              this.show = '';
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "single-select-horizontal-grid") {
        if (this.rowList > 0) {
          let widthScreen = window.innerWidth;
          if (widthScreen > 768) {
            this.surveyDetail.rowOptionList.forEach((col, k) => {
              if (this.setData[this.surveyDetail.var] == this.rowResponse[k].optionCode) {
                this.el.nativeElement.querySelector('#horzi' + k).checked = true;
                if (this.totalVideo.length > 0) {
                  this.videoPlayed = 1;
                }
              }
            });
          } else {
            this.surveyDetail.rowOptionList.forEach((col, a) => {
              if (this.setData[this.surveyDetail.var] == this.rowResponse[a].optionCode) {
                this.el.nativeElement.querySelector('#horziMob' + a).checked = true;
                if (this.totalVideo.length > 0) {
                  this.videoPlayed = 1;
                }
              }
            });
          }
        }
      }
      else if (this.surveyDetail.qType == "numeric-row-list") {
        if (this.rowList > 0) {
          this.rowResponse.forEach((row, a) => {
            if (row.exclusive == 1) {
              if (this.setData[row.var] == 1) {
                this.el.nativeElement.querySelector('#num' + a).checked = true;
              }
            } else {
              if (a == 0 && row.default == 1 && this.setData[row.var] == 0) {
                this.el.nativeElement.querySelector("#numUp" + row.var).value = row.default;
              }
              if (row.other == 1 && this.setData[row.var + "_other"]) {
                this.el.nativeElement.querySelector("#" + row.var + "_other").value = this.setData[row.var + "_other"];
                this.el.nativeElement.querySelector("#numUp" + row.var).value = this.setData[row.var];
              } else if (row.other == 0 && this.setData[row.var]) {
                this.el.nativeElement.querySelector("#numUp" + row.var).value = this.setData[row.var];
              }
            }
            if (this.setData[row.var] > 0 && this.totalVideo.length > 0) {
              this.videoPlayed = 1;
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "percentage-row-list") {
        if (this.rowList > 0) {
          this.surveyDetail.rowOptionList.forEach(rowper => {
            if (this.setData[rowper.var + "_other"] && rowper.other == 1) {
              this.el.nativeElement.querySelector('#oth_' + rowper.var).value = this.setData[rowper.var + "_other"];
            }
            if (rowper.exclusive == 0) {
              if (this.setData[rowper.var] > 0) {
                this.el.nativeElement.querySelector("#" + rowper.var).value = this.setData[rowper.var]
              } else {
                this.el.nativeElement.querySelector("#" + rowper.var).value = "";
              }
            } else if (rowper.exclusive == 1 && this.setData[rowper.var] == 1) {
              this.el.nativeElement.querySelector("#per_" + rowper.var).checked = true;
            }

            if (this.setData[rowper.var] > 0 && this.totalVideo.length > 0) {
              this.videoPlayed = 1;
            }
          });
        }
      }
      else if (this.surveyDetail.qType == "drag-n-drop-ranking-column") {
        if (Object.values(this.setData)) {
          this.mainDropArr = [];
          this.responseArr = [];
          let lcArr = [];

          this.surveyDetail.rowOptionList.forEach(dragDual => {
            if (this.setData[dragDual.var] == 0 || this.setData[dragDual.var] == null) {
              this.mainDropArr.push(dragDual);
            } else {
              lcArr.push({
                "key": dragDual.var,
                "value": this.setData[dragDual.var],
                "set": dragDual
              });
            }
          });

          lcArr.sort((a, b) => (a.value > b.value) ? 1 : -1)
          lcArr.forEach(sTdata => {
            this.responseArr.push(sTdata.set);
          });

          if (lcArr.length > 0 && this.totalVideo.length > 0) {
            this.videoPlayed = 1;
          }
        }
        else {
          if (this.surveyDetail.qType == "drag-n-drop-ranking-column") {
            response["rowOptionList"].forEach(drop => {
              this.mainDropArr.push(drop);
            });
          }
        }
      }
      else if (this.surveyDetail.qType == "single-select-drop-down") {
        if (this.setData[this.surveyDetail.var]) {
          this.el.nativeElement.querySelector("#drop_down_" + this.surveyDetail.var).value = this.setData[this.surveyDetail.var];
        }
        if (this.totalVideo.length > 0 && this.setData[this.surveyDetail.var]) {
          this.videoPlayed = 1;
        }
      }
      else if (this.surveyDetail.qType?.toLowerCase() == "text-highlighter") {
        this.setTextHighlighter(response);
      } else if (this.surveyDetail.qType == "image-heatmap") {
        this.setImageHeatmap(response);
      }
      else if (this.surveyDetail.qType == "max-diff") {
        this.respVar = [];
        this.surveyDetail.attributeSeq.forEach(element => {
          element.values['maxW'] = this.setData[this.surveyDetail.qID + '_max' + element.set + '_W'];
          element.values['maxB'] = this.setData[this.surveyDetail.qID + '_max' + element.set + '_B'];
        });
        this.surveyDetail.attributeSeq[0].items.forEach(grid => {
          if (this.surveyDetail.attributeSeq[0].values['maxB'] == grid) {
            this.el.nativeElement.querySelector("#maxdiff_" + this.surveyDetail.attributeSeq[0].set + '_' + grid + '_' + 0).click();
          }
          else if (this.surveyDetail.attributeSeq[0].values['maxW'] == grid) {
            this.el.nativeElement.querySelector("#maxdiff_" + this.surveyDetail.attributeSeq[0].set + '_' + grid + '_' + 1).click();
          }
        });
      }
      if (this.surveyDetail.test_mode == 0 && this.surveyDetail.qType == "grid-row-single-select-carousel") {
        this.el.nativeElement.querySelector(".next-slide").classList.add("d-none");
        this.el.nativeElement.querySelector(".prev-slide").classList.add("d-none");
      }

      if (this.totalVideo.length > 0) {
        let count = 0;
        this.videoCount = {};

        this.totalVideo.forEach(q2 => {
          let vid = this.el.nativeElement.querySelector("#con_val" + q2.id);
          let myVar = setInterval(() => {
            if (vid) {
              if (vid.currentTime == vid.duration) {
                count += 1;
                let videoId = q2.id.substring(0, q2.id.length - 2);
                this.masterData[this.pipeinvariables["ID"] + videoId] = videoId;
                this.setSession(this.masterData);
                if (this.surveyDetail.qType == "grid-row-single-select-carousel" && count == this.qTextVideo.length) {
                  this.surveyDetail["rowOptionList"].forEach(row => {
                    let getAll = this.el.nativeElement.querySelectorAll(".getRow");
                    getAll.forEach(ele => {
                      ele.classList.remove("p-none");
                    });
                  });
                }

                if (count == this.totalVideo.length) {
                  if (this.surveyDetail.qType == "grid-row-single-select-carousel") {
                    let getAll = this.el.nativeElement.querySelectorAll(".p-none");
                    getAll.forEach(ele => {
                      ele.classList.remove("p-none");
                    });
                  }

                  if (this.surveyDetail.qType != "grid-row-single-select-carousel") {
                    this.videoPlayed = 1;
                    this.masterData[this.pipeinvariables["ID"] + videoId] = videoId;
                    this.setSession(this.masterData);
                  }
                }

                if (this.videoCount[videoId]) {

                } else {
                  this.videoCount[videoId] = videoId;
                }
                clearInterval(myVar);
              }
            }
          }, 1000);
        });
      }
    },
      (error) => {
        if (error.status == 500) {
          swal({
            icon: environment.errorIcon,
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "custom-button-color",
                closeModal: true
              },
            },
            type: "error",
            text: "Please try after some time",
            title: "There was a problem processing your request"
          });
        }
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: error.error.header.message,
        });
        // swal("", error.error.header.message, "error");
      });
  }

  // Session enc
  encFrData() {
    let ec = btoa(this.finalData["token"]);
    return ec;
  }

  encryptData(data) {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
    } catch (e) {

    }
  }

  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {

    }
  }

  // End Enc

  othersMultiple(event, list) {
    this.surveyDetail.rowOptionList.forEach((row, i) => {
      if (row.var == list.var && list.other == 1 && row.other == 1) {
        this.el.nativeElement.querySelector("#list" + i).checked = true;
      }

      if (row.exclusive == 1) {
        this.el.nativeElement.querySelector("#list" + i).checked = false;
      }
    });
  }

  playVideo(qtxt, index, last) {
    if (qtxt.type == "video") {
      let vid
      if (this.surveyDetail.qID == "Q2") {
        vid = this.el.nativeElement.querySelector("#con_val_op" + qtxt.id);
      }
      else {
        if (this.getBrowser == true) {
          vid = this.el.nativeElement.querySelector("#con_val_mob" + qtxt.id);
        } else {
          vid = this.el.nativeElement.querySelector("#con_val_op" + qtxt.id);
        }
      }
      let myVar = setInterval(() => {
        if (vid) {
          if (vid.currentTime >= vid.duration) {
            let videoId = qtxt.id.substring(0, qtxt.id.length - 2);
            this.masterData[this.pipeinvariables["ID"] + videoId] = videoId;
            this.setSession(this.masterData);
            if (this.videoCount[videoId]) {

            } else {
              this.videoCount[videoId] = videoId;
            }
            if (this.surveyDetail.qType == "grid-row-single-select-carousel") {
              if (last == false) {
                this.el.nativeElement.querySelector("#next" + index).classList.remove("d-none");
              }
              this.surveyDetail["colOptionList"].forEach((row, i) => {
                if (this.getBrowser == true) {
                  this.el.nativeElement.querySelector(".pe-none-mob" + i + "_" + index).classList.remove("p-none");
                } else {
                  this.el.nativeElement.querySelector(".pe-none" + i + "_" + index).classList.remove("p-none");
                }
              });
            } else {
              var check = true
              this.totalVideo.forEach(v => {
                Object.keys(this.videoCount).forEach(e => {
                  if (v.id.substring(0, qtxt.id.length - 2) != e) {
                    check = false;
                  }
                })
              })
              if (check) {
                this.videoPlayed = 1;
                this.masterData[this.pipeinvariables["ID"] + videoId] = videoId;
                this.setSession(this.masterData);
              }
            }
            clearInterval(myVar);
          }
        }
      }, 1000);
    }
  }

  playqTextVideo(q2) {
    let vid = this.el.nativeElement.querySelector("#con_val" + q2.id);
    let myVar = setInterval(() => {
      if (vid) {
        if (vid.currentTime == vid.duration) {
          let videoId = q2.id.substring(0, q2.id.length - 2);
          this.masterData[this.pipeinvariables["ID"] + videoId] = videoId;
          this.setSession(this.masterData);
          this.videoPlayed = 1;
          clearInterval(myVar);
        }
      }
    }, 1000);
  }

  // **============================================== Start Auth Catlina process ===============================================**
  // **========================================================================================================================**
  authCatlina() {
    let catId = this.el.nativeElement.querySelector("#catVal").value;
    this.masterData = this.getSession();
    let countAt = "";
    let provider = "";
    if (this.masterData != undefined) {
      countAt = this.masterData['attempt'];
      provider = this.masterData['_ctl' + this.finalData["zone"]];
    }
    let ctAt = parseInt(countAt);
    let catId1 = catId.length;
    let countAttempt = 0;
    if (countAt == null) {
      countAttempt += 1;
    }
    if (ctAt > 0) {
      countAttempt += ctAt;
    }

    if (catId1 > 1 && countAttempt <= 3 && provider != "") {
      this.apiUrlProgress = this.crurl + this.apiType + '/external/' + provider + "/" + this.studyId;
      this.http.post(this.apiUrlProgress, {
        "id": catId,
        "pipe-in": this.pipeinvariables
      }).subscribe(response => {
        if (response) {
          this.masterData[this.finalData["zone"]] = catId;
          this.setSession(this.masterData);
          this.identify = '';
          this.initialFnCalls();
        }
      },
        (error) => {
          if (error.status == 404) {
            if (error.error.header.message == "Unable to match ID!") {
              countAttempt += 1;
              let data = String(countAttempt);
              this.masterData['attempt'] = data;
              this.setSession(this.masterData);
            }
          }
          if (error.status == 500) {
            swal({
              icon: environment.errorIcon,
              buttons: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  className: "custom-button-color",
                  closeModal: true
                },
              },
              type: "error",
              text: "Please try after some time",
              title: "There was a problem processing your request"
            });
          } else {
            if (error.error) {
              if (error.status) {
                swal({
                  button: false,
                  text: error.error.header.message,
                  icon: environment.errorIcon,
                  buttons: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      className: "custom-button-color",
                      closeModal: true
                    },
                  },
                });
              }
            }
          }
        });
    }
    else {
      if (countAttempt > 3) {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: "You have exceed no of attempts",
        });
        // swal("", "You have exceed no of attempts", "error");
      } else {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: "Response is required please enter valid PIN",
        });
      }
    }
  }
  // **============================================== End Auth Catlina process ===============================================**
  // **=======================================================================================================================**

  getData(event, last) {
    if (event.target.checked == true) {
      let checkedValue = this.el.nativeElement.querySelectorAll("input.carusoleOptions:checked");
      this.arrlength = checkedValue.length;
      if ((checkedValue.length < this.surveyDetail.rowOptionList.length) && last == false) {
        // #gridCarusole (desktop, including the >7-option radio list) and
        // #gridCarusoleMob (mobile) are two separate Bootstrap carousel
        // instances. Simulating a click on a "next" anchor depends on that
        // anchor being resolvable/bubbling correctly and can end up
        // targeting the wrong instance. Instead, find the specific carousel
        // the clicked option actually lives in and drive it directly via
        // Bootstrap's carousel API, so it always advances the one the user
        // is really looking at.
        const carouselEl = event.target.closest('.carousel');
        if (carouselEl && typeof $ !== 'undefined') {
          $(carouselEl).carousel('next');
        } else {
          const carouselItem = event.target.closest('.carousel-item');
          const nextBtn = carouselItem ? carouselItem.querySelector('.carousel-control-next') : null;
          if (nextBtn) {
            nextBtn.click();
          } else if (this.getBrowser == true) {
            this.el.nativeElement.querySelector(".mob-next").click();
          } else {
            this.el.nativeElement.querySelector(".carousel-control-next").click();
          }
        }
      }

      if ((Object.keys(this.videoCount).length == this.totalVideo.length) && (checkedValue.length == this.surveyDetail.rowOptionList.length) && this.totalVideo.length > 0) {
        this.videoPlayed = 1;
      }
    }
  }

  // responsiveWidth() {
  //   let maxwidth = {
  //     'width.%': this.boxLen,

  //   };
  //   return maxwidth;
  // }

  private carouselCanvas: HTMLCanvasElement;

  private measureWordWidth(word: string, font: string): number {
    if (!this.carouselCanvas) {
      this.carouselCanvas = document.createElement('canvas');
    }
    const ctx = this.carouselCanvas.getContext('2d');
    if (!ctx) {
      return 0;
    }
    ctx.font = font;
    return ctx.measureText(word).width;
  }

  private getLongestCarouselWordWidth(): number {
    let maxWidth = 0;
    const font = '20px Poppins, sans-serif';
    const cols = this.surveyDetail?.colOptionList || [];
    cols.forEach((cl: any) => {
      (cl.optionText || []).forEach((q: any) => {
        if (q.type === 'string') {
          const plain = (q.detail || '').replace(/<[^>]*>/g, '').trim();
          plain.split(/\s+/).filter(Boolean).forEach((word: string) => {
            const w = this.measureWordWidth(word, font);
            if (w > maxWidth) {
              maxWidth = w;
            }
          });
        }
      });
    });
    return maxWidth;
  }

  private getCarouselContainerWidth(): number {
    const rowEl = this.el?.nativeElement?.querySelector('#gridCarusole .getRow .carousel-item.active .row');
    return rowEl ? rowEl.offsetWidth : 0;
  }

  private getLongestWordWidthForColumn(cl: any, font: string): number {
    let maxWidth = 0;
    (cl?.optionText || []).forEach((q: any) => {
      if (q.type === 'string') {
        const plain = (q.detail || '').replace(/<[^>]*>/g, '').trim();
        plain.split(/\s+/).filter(Boolean).forEach((word: string) => {
          const w = this.measureWordWidth(word, font);
          if (w > maxWidth) {
            maxWidth = w;
          }
        });
      }
    });
    return maxWidth;
  }

  // Header (thead) width for every grid question type's answer-option
  // columns. Mobile (<768px) is completely untouched — it returns the exact
  // same value responsiveWidthGrid() already returns today. This only
  // affects thead th cells; tbody's existing first-col implementation is
  // untouched (this method isn't used there), and every other grid behavior
  // (body cells, carousel questions) is unaffected since it doesn't call
  // or change responsiveWidthGrid()/grid_single_len/showScroll at all.
  responsiveHeaderWidthGrid(cl: any) {
    if (typeof window === 'undefined' || window.innerWidth < 768) {
      return this.responsiveWidthGrid();
    }
    if (this.showScroll) {
      // Scroll mode: every column gets exactly what its own longest word
      // needs — not a single value shared by every column — so narrower
      // columns don't waste space just because another column is wider.
      const font = '16px Poppins, sans-serif';
      const padding = 20;
      const neededPx = this.getLongestWordWidthForColumn(cl, font) + padding;
      return { width: `${neededPx}px` };
    }
    // No-scroll mode: plain even share. We deliberately don't grow individual
    // columns past this here — doing so while showScroll stays false would
    // push the header row's total width past 100% on its own, which is what
    // was causing the scrollbar to appear even on tables that fit fine.
    // checkGridOverflow() is the single source of truth for whether scroll
    // is actually needed.
    return this.responsiveWidthGrid();
  }

  private isGridTableQType(qType: string): boolean {
    return qType === 'grid-row-single-select'
      || qType === 'grid-column-single-select'
      || qType === 'grid-row-multiple-select'
      || qType === 'grid-column-multiple-select';
  }

  private updateGridColumnSizing(): void {
    if (!this.isGridTableQType(this.surveyDetail?.qType) || !this.columnLen) {
      return;
    }
    // Always start from the simple, even-percentage layout and trust the
    // header CSS (white-space:normal + word-break:keep-all) to wrap a
    // multi-word header onto a new line — e.g. "Project Management" wraps
    // after "Project", "Management" stays whole. Pre-computing a pixel
    // budget from canvas-measured word widths kept producing false-positive
    // scroll (font-metric/box-model estimates never quite matched the real
    // render), and grew columns wider than the wrap actually needed. Instead,
    // render this first and only escalate to scroll if it genuinely overflows.
    this.showScroll = false;
    this.grid_single_len = 100 / this.columnLen;
    this.tableMinWidth = '100%';
    this.topScrollWidth = '100%';
    setTimeout(() => this.checkGridOverflow(), 0);
  }

  private checkGridOverflow(): void {
    if (!this.isGridTableQType(this.surveyDetail?.qType)) {
      return;
    }
    const wrapperEl: HTMLElement = this.el?.nativeElement?.querySelector('.table-scroll-wrapper');
    if (!wrapperEl || !wrapperEl.scrollWidth) {
      return;
    }
    if (wrapperEl.scrollWidth <= wrapperEl.clientWidth + 1) {
      // Fits as rendered — nothing more to do, columns stay at their plain
      // even share instead of being needlessly widened.
      return;
    }
    // Genuine overflow even after wrapping — a column's own longest word
    // truly doesn't fit. Fall back to horizontal scroll, sizing each column
    // to exactly what its own longest word needs (never breaking it).
    const font = '16px Poppins, sans-serif';
    const gridWordPadding = 20;
    const gridFirstColWidth = window.innerWidth >= 768 ? 200 : 150; // matches .first-col's CSS width at this breakpoint
    let longestWordAcrossAll = 0;
    let totalColumnsWidth = 0;
    (this.surveyDetail?.colOptionList || []).forEach((cl: any) => {
      const w = this.getLongestWordWidthForColumn(cl, font);
      if (w > longestWordAcrossAll) {
        longestWordAcrossAll = w;
      }
      totalColumnsWidth += w + gridWordPadding;
    });
    this.showScroll = true;
    this.grid_single_len = longestWordAcrossAll + gridWordPadding;
    this.tableMinWidth = `${gridFirstColWidth + totalColumnsWidth}px`;
    this.topScrollWidth = `${gridFirstColWidth + totalColumnsWidth}px`;
  }

  // Only used when columnLen <= 7 (see survey.component.html); above 7
  // options the template switches to the radio-list block instead, which
  // mirrors the mobile view and doesn't call this.
  responsiveWidth() {
    const baseWidth = 100 / this.columnLen;
    const containerWidth = this.getCarouselContainerWidth();
    const longestWordPx = this.getLongestCarouselWordWidth();
    const padding = 40;
    let width = baseWidth;
    if (containerWidth > 0 && longestWordPx > 0) {
      const neededPercent = ((longestWordPx + padding) / containerWidth) * 100;
      width = Math.max(baseWidth, neededPercent);
    }
    return {
      width: width + '%'
    };
  }

  // Keeps up to 7 options left-aligned on a single row. Only used when
  // columnLen <= 7 (see survey.component.html).
  getContainerStyle() {
    return {
      display: 'flex',
      'flex-wrap': 'nowrap',
      'justify-content': 'flex-start',
    };
  }

  responsiveWidthCarusole() {
    let maxwidth = {
      'width.%': this.boxLenCarusole,

    };
    return maxwidth;
  }

  // responsiveWidthGrid() {
  //   let maxwidthGrid = {
  //     'width.%': this.grid_single_len,

  //   };
  //   return maxwidthGrid;
  // }

  responsiveWidthGrid() {
    return this.showScroll
      ? { width: `${this.grid_single_len}px` }
      : { width: `${this.grid_single_len}%` };
  }

  syncScroll(origin: 'top' | 'bottom') {
    const top = this.scrollTop.nativeElement;
    const bottom = this.scrollBottom.nativeElement;
    const scrollLeft = origin === 'top' ? top.scrollLeft : bottom.scrollLeft;

    if (origin === 'top') {
      bottom.scrollLeft = top.scrollLeft;
    } else {
      top.scrollLeft = bottom.scrollLeft;
    }

  }





  survey(eve, list) {
    if (eve.key == 'e' || eve.key == "." || eve.key == '-' || eve.key == "+") {
      this.el.nativeElement.querySelector("#sumUp" + list.var).value = '';
      swal({
        icon: environment.errorIcon,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "custom-button-color",
            closeModal: true
          },
        },
        type: "error",
        text: "Invalid response",
      });
    }

    let sumVal = this.el.nativeElement.querySelectorAll(".sumAll");
    let total = 0;
    let finalSum = 0;
    let errorData = 0;
    let sumValMax = this.surveyDetail["MAX-SELECTION"];

    if (sumValMax == "" || sumValMax == 0) {
      sumValMax = 100;
    }

    sumVal.forEach(sum => {
      if (sum.value == "" || sum.value < this.surveyDetail["MIN-SELECTION"] || sum.value > this.surveyDetail["MAX-SELECTION"]) {
        errorData += 1;
      }
    });

    this.surveyDetail.rowOptionList.forEach(sum => {
      if (sum.exclusive == 1) {
        this.el.nativeElement.querySelector("#list_" + sum.var).checked = false;
      }
    });

    if (errorData <= sumVal.length) {
      sumVal.forEach(element => {
        if (element.value == "") {
          total += 0;
          finalSum += 0;
        }
        else {
          total += parseInt(element.value);
        }

        this.el.nativeElement.querySelector("#totalData").value = total;
      });
    }
  }

  rankSr(event) {
    if (event.target.checked == true) {
      this.surveyDetail.rowOptionList.forEach(rank => {
        if (rank.exclusive != 1) {
          this.el.nativeElement.querySelector("#" + rank.var).value = "";
        }

        if (rank.other == 1) {
          this.el.nativeElement.querySelector("#" + rank.var + "_other").value = "";
        }
      });

    }
  }

  othRank(event) {
    if (event.key == "." || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = '';
    } else {
      this.surveyDetail.rowOptionList.forEach(rank => {
        if (rank.exclusive == 1) {
          this.el.nativeElement.querySelector("#rank_" + rank.var).checked = false;
        }
      });
    }
  }

  multiSelect(element, list) {
    if (list.exclusive == 1) {
      this.rowResponse.forEach((row, k) => {
        if (list.var != row.var) {
          this.el.nativeElement.querySelector('#list' + k).checked = false;
          if (row.other == 1) {
            this.el.nativeElement.querySelector(".oth" + row.var).value = "";
          }
        }
      });
    } else {
      this.rowResponse.forEach((row, k) => {
        if (row.exclusive == 1) {
          this.el.nativeElement.querySelector('#list' + k).checked = false;
        }
        if (element.target.checked == false && row.other == 1 && list.var == row.var) {
          this.el.nativeElement.querySelector(".oth" + list.var).value = "";
        }
        if (list.exclusive == 0 && row.default == 1) {
          this.el.nativeElement.querySelector('#list' + k).checked = true;
        }
      });
    }
  }

  singleSelect(event) {
    this.surveyDetail.rowOptionList.forEach(row => {
      if (row.optionCode == event.target.value) {

      } else if (row.other == 1) {
        this.el.nativeElement.querySelector(".othSin" + row.var + row.optionCode).value = "";
      }
    });
  }

  singleOther(event, list) {
    this.surveyDetail.rowOptionList.forEach((row, i) => {
      if (row.optionCode == list.optionCode) {
        this.el.nativeElement.querySelector("#sin" + i).checked = true;
      } else if (row.other == 1) {
        this.el.nativeElement.querySelector(".othSin" + row.var + row.optionCode).value = "";
      }
    });
  }

  getFavData(event) {
    let checkedValue = this.el.nativeElement.querySelectorAll("input.favorite:checked");
    let recentId = event.target.id;
    let recenetVal = event.target.value;
    checkedValue.forEach(item => {
      if (recentId != item.id && recenetVal == item.value) {
        let makeId = "#" + item.id;
        this.el.nativeElement.querySelector(makeId).checked = false;
      }
    });
  }

  openEndNat(event, row) {
    if (event.target.checked == true) {
      this.openEndCheck = row.var;
      this.projectCreation.get("projectpeople").patchValue("");
    } else if (event.target.checked == false) {
      this.openEndCheck = '';
      this.respVar = {};
    }
  }

  checkColOption() {
    let colLength = this.surveyDetail.colOptionList.length;
    let checkColLen = 0;
    this.surveyDetail.colOptionList.forEach(item => {
      let thisVar = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked").length;
      if (thisVar == 1) {
        checkColLen += 1;
      }
    });

    if ((colLength == checkColLen && this.rowList > 1) || (checkColLen > 0 && this.rowList == 1)) {
      return true;
    } else {
      return false;
    }
  }

  checkRowOption() {
    let rowLength = this.surveyDetail.rowOptionList.length;
    let checkColLen = 0;
    this.surveyDetail.rowOptionList.forEach(item => {
      let thisVar = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked").length;
      if (thisVar == 1) {
        checkColLen += 1;
      }
    });

    if ((rowLength == checkColLen && this.rowList > 1) || (checkColLen > 0 && this.rowList == 1)) {
      return true;
    } else {
      return false;
    }
  }

  checkValue(event: any, list, rowOp) {
    const pattern = /[0-9]/;
    let inputChar = event.key;
    if (!pattern.test(inputChar)) {
      let id = "#" + list.var;
      this.el.nativeElement.querySelector(id).value = '';
    }

    rowOp.forEach(rw => {
      if (rw.exclusive == 1 && list.exclusive == 0) {
        this.el.nativeElement.querySelector("#rank_" + rw.var).checked = false;
      }
    });
  }

  colMultiSelect(event, gridList, colList) {
    if (event.target.checked == true && gridList.exclusive == 1) {
      let allColchecks = this.el.nativeElement.querySelectorAll("input.colLen" + colList.optionCode);
      allColchecks.forEach(notCheck => {
        if (event.target.id != notCheck.id) {
          this.el.nativeElement.querySelector("#" + notCheck.id).checked = false;
        }
      });
    } else {
      let allColchecks = this.el.nativeElement.querySelectorAll("input.colLen" + colList.optionCode);
      allColchecks.forEach(notCheck => {
        let exclusive = notCheck.getAttribute('dataexclusive');
        if (exclusive == 1) {
          this.el.nativeElement.querySelector("#" + notCheck.id).checked = false;
        }
      });
    }
  }

  rowMultiSelect(event, gridList, colList) {
    if (event.target.checked == true && colList.exclusive == 1) {
      let allColchecks = this.el.nativeElement.querySelectorAll("input.colRow" + gridList.optionCode);
      allColchecks.forEach(notCheck => {
        if (event.target.id != notCheck.id) {
          this.el.nativeElement.querySelector("#" + notCheck.id).checked = false;
        }
      });
    } else {
      let allColchecks = this.el.nativeElement.querySelectorAll("input.colRow" + gridList.optionCode);
      allColchecks.forEach(notCheck => {
        let exclusive = notCheck.getAttribute('rowexclusive');
        if (exclusive == 1) {
          this.el.nativeElement.querySelector("#" + notCheck.id).checked = false;
        }
      });
    }
  }

  numSr(event) {
    const checkboxes = this.el.nativeElement.querySelectorAll(".numCheck");
    if (event.target.checked) {
      checkboxes.forEach((checkbox: HTMLInputElement) => {
        if (checkbox !== event.target && checkbox.getAttribute("dataexclusive") === "1") {
          checkbox.checked = false;
        }
      });
      this.surveyDetail.rowOptionList.forEach(row => {
        if (row.exclusive == 0) {
          this.el.nativeElement.querySelector("#numUp" + row.var).value = '';
        }
        if (row.other == 1) {
          this.el.nativeElement.querySelector("#" + row.var + "_other").value = '';
        }
      });
    } else {
      if (this.surveyDetail.qID == "D2" || this.surveyDetail.qID == "d2") {
        let getAllNum = this.el.nativeElement.querySelectorAll(".getAllNumvalue");
        getAllNum.forEach((ele, i) => {
          let splitNum = ele.name.split("=");
          let varData = splitNum[0];
          if (i == 0) {
            this.el.nativeElement.querySelector("#numUp" + varData).value = 1;
          }
        });
      }
    }
  }


  numOth(event) {
    if (event.key == "." || event.key == '-' || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = '';
    }
    else {
      this.surveyDetail.rowOptionList.forEach((row, i) => {
        if (row.exclusive == 1) {
          this.el.nativeElement.querySelector("#num" + i).checked = false;
        }
      });
    }
  }

  handleNumericInput(event: any): void {
    clearTimeout(this.inputTimeout); // Clear any existing timeout
    this.inputTimeout = setTimeout(() => {
      this.numericTab(event); // Call the original validation method after a delay
    }, 500); // Delay of 500ms
  }

  numericTab(event) {
    if (event.key == "." || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = '';
    } else {
      if (event.target.value > this.numericMax) {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: "Response can only be between " + this.numericMin + " and " + this.numericMax + " ",
        });
        this.el.nativeElement.querySelector("#" + event.target.id).value = '';
      } else if (event.target.value < this.numericMin) {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: "Response can only be between " + this.numericMin + " and " + this.numericMax + " ",
        });
        this.el.nativeElement.querySelector("#" + event.target.id).value = '';
      }
      if (event.target.value != '') {
        this.rowResponse.forEach((dataEle, i) => {
          if (dataEle.exclusive == 1) {
            this.el.nativeElement.querySelector("#num" + i).checked = false;
          }
        });
      }
    }
  }



  getopEnd(event) {
    if (event.key) {
      this.el.nativeElement.querySelector("#op_end_lg").checked = false;
    }
  }

  openEndL(event) {
    if (event.target.checked == true) {
      this.el.nativeElement.querySelector("#opLarge").value = '';
    } else {
      this.el.nativeElement.querySelector("#op_end_lg").checked = false;
    }
  }

  getopEndMd(event) {
    if (event.key) {
      this.el.nativeElement.querySelector("#op_end_md").checked = false;
    }
  }

  openEndMd(event) {
    if (event.target.checked == true) {
      this.el.nativeElement.querySelector("#openEndMedium").value = '';
    } else {
      this.el.nativeElement.querySelector("#op_end_md").checked = false;
    }
  }

  percentageRow(event) {
    this.surveyDetail.rowOptionList.forEach(row => {
      if (row.exclusive == 1) {
        this.el.nativeElement.querySelector("#per_" + row.var).checked = false;
      }
    });

    if (event.key == "." || event.key == '-' || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = '';
    } else {
      if (event.target.value >= this.surveyDetail["MIN-SELECTION"] && event.target.value <= this.surveyDetail["MAX-SELECTION"]) {

      } else {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: "Response can only be between " + this.surveyDetail["MIN-SELECTION"] + " and " + this.surveyDetail["MAX-SELECTION"] + " ",
        });
        this.el.nativeElement.querySelector("#" + event.target.id).value = '';
      }
    }
  }

  percentageRowOther(event) {
    if (event.key == "." || event.key == '-' || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = '';
      swal({
        icon: environment.errorIcon,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "custom-button-color",
            closeModal: true
          },
        },
        type: "error",
        text: "Invalid response",
      });
    }
  }

  perOther(event) {
    if (event.key == "." || event.key == '-' || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = '';
    }
    this.surveyDetail.rowOptionList.forEach(element => {
      if (element.exclusive == 1) {
        this.el.nativeElement.querySelector("#per_" + element.var).checked = false;
      }
    });
  }

  perSr(event) {
    if (event.target.checked == true) {
      this.surveyDetail.rowOptionList.forEach(element => {
        if (element.exclusive == 0) {
          this.el.nativeElement.querySelector("#" + element.var).value = '';
        }

        if (element.other == 1) {
          this.el.nativeElement.querySelector("#oth_" + element.var).value = '';
        }
      });
    }
  }

  // Multiple select condition
  preventInput(event) {
    if (event.key == "." || event.key == '-' || event.key == "+") {
      this.projectCreation.get("projectpeople").patchValue("");
    } else {
      this.el.nativeElement.querySelector("#notPrefer").checked = false;
    }
  }

  sumUpTo(event) {
    if (event.target.checked == true && event.target.value == 1) {
      this.el.nativeElement.querySelector("#totalData").value = "";
      this.surveyDetail.rowOptionList.forEach(sum => {
        if (sum.exclusive == 0) {
          this.el.nativeElement.querySelector("#sumUp" + sum.var).value = "";
        }
        if (sum.other == 1) {
          this.el.nativeElement.querySelector("#" + sum.var + "_other").value = "";
        }
      });
    }
  }

  sumOth(event) {
    if (event.key == "." || event.key == "+") {
      this.el.nativeElement.querySelector("#" + event.target.id).value = "";
    } else {
      this.surveyDetail.rowOptionList.forEach((row, i) => {
        if (row.exclusive == 1) {
          this.el.nativeElement.querySelector("#list_" + row.var).checked = false;
        }
      });
    }
  }

  stripHtml(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  isMobileDevice() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
    return check;
  };

  pauseVideo() {
    this.surveyDetail?.expandedDetail.forEach(row => {
      if (row.type == "video") {
        this.el.nativeElement.querySelector(".responsive_video").pause();
      }
    });
  }

  pauseVid(row) {
    row.optionText.forEach(rw => {
      if (rw.type == "video") {
        this.el.nativeElement.querySelector(".video-full" + rw.id).pause()
      }
    });
  }

  getSource(val) {
    let mkData = atob(val);
    return mkData;
  }

  getSession() {
    let lcData = sessionStorage.getItem(this.encFrData());
    if (lcData != null) {
      let sendData = this.decryptData(JSON.parse(lcData));
      this.masterData = sendData;
      return sendData;
    }
  }

  setSession(savedata) {
    let reMain = this.encryptData(savedata);
    sessionStorage.setItem(this.encFrData(), JSON.stringify(reMain));
  }

  clearSession() {
    sessionStorage.clear();
  }


  checkMinMaxForMultipleColumn() {
    let countChecked = [];
    let countNotChecked = [];
    this.surveyDetail.colOptionList.forEach(col => {
      if (this.getBrowser == true) {
        let checked = this.el.nativeElement.querySelectorAll(".mob_col" + col.var + ":checked");
        let exl = 0;
        if (checked.length > 0) {
          checked.forEach(element => {
            let splitData = element.getAttribute("dataexclusive");
            if (splitData == 1) {
              exl += 1;
            }
          });
        }

        if (exl == 0 && checked.length >= this.surveyDetail["MIN-SELECTION"] && checked.length <= this.surveyDetail["MAX-SELECTION"]) {
          countChecked.push(col.var);
        }
        else if (exl > 0 && checked.length == 1) {
          countChecked.push(col.var);
        }
        else {
          countNotChecked.push(col.optionText);
        }
      }
      else if (this.getBrowser == false) {
        let checked = this.el.nativeElement.querySelectorAll(".desk_col" + col.var + ":checked");
        let exl = 0;
        if (checked.length > 0) {
          checked.forEach(element => {
            let splitData = element.getAttribute("dataexclusive");
            if (splitData == 1) {
              exl += 1;
            }
          });
        }

        if (exl == 0 && checked.length >= this.surveyDetail["MIN-SELECTION"] && checked.length <= this.surveyDetail["MAX-SELECTION"]) {
          countChecked.push(col.var);
        }
        else if (exl > 0 && checked.length == 1) {
          countChecked.push(col.var);
        }
        else {
          countNotChecked.push(col.optionText);
        }
      }
    });

    return countNotChecked;
  }

  // **============================================== Save Api For Survey===============================================**
  // **=================================================================================================================**

  saveSurvey() {

    this.getBrowser = this.isMobileDevice();
    this.showCard = false;
    this.pre = 0;
    this.respVar = {};
    let rowLen = this.rowResponse.length;
    let pass = 0;
    let row_arr_other = [];
    let row_arr_no_other = [];
    let error = 0
    // Row list array
    this.surveyDetail.rowOptionList.forEach((survey, i) => {
      survey['index'] = i;
      if (survey.other == 1) {
        row_arr_other.push(survey);
      } else {
        row_arr_no_other.push(survey);
      }
    });

    // Collist  array
    let col_arr_other = [];
    let col_arr_no_other = [];
    this.surveyDetail.colOptionList.forEach((survey, i) => {
      survey['index'] = i;
      if (survey.other == 1) {
        col_arr_other.push(survey);
      } else {
        col_arr_no_other.push(survey);
      }
    });

    if (this.surveyDetail.qType == "open-end-small" && rowLen == 0) {
      let respData = this.el.nativeElement.querySelector("#dataVal").value;
      this.inputData = respData.trim();
      let pattern = /^[0-9_]+( [0-9_]+)*$/;
      if (!this.inputData.match(pattern)) {
        this.el.nativeElement.querySelector("#dataVal").value = '';
        this.error_text_to_print = "Please enter numeric value only";
      } else {
        let min = Number.MIN_VALUE;
        let max = Number.MIN_VALUE;
        min = this.numericMin;
        max = this.numericMax;
        if (min >= 0 && max >= min) {
          try {
            let min_n = min;
            let max_n = max;
            //console.log(this.inputData < this.surveyDetail["MIN-SELECTION"], this.inputData > this.surveyDetail["MAX-SELECTION"], this.surveyDetail['group'] == "demographics", this.surveyDetail['group'] == "screener")
            if ((this.inputData < this.surveyDetail["MIN-SELECTION"] || this.inputData > this.surveyDetail["MAX-SELECTION"]) && (this.surveyDetail['group'] == "demographics" || this.surveyDetail['group'] == "screener")) {
              this.el.nativeElement.querySelector("#dataVal").classList.add("err_block");
              swal({
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                type: "error",
                text: "Response can only be between " + this.surveyDetail["MIN-SELECTION"] + " and " + this.surveyDetail["MAX-SELECTION"] + ".",
              });
              this.showCard = true;
              pass += 1;
            }

            else if ((this.inputData < this.surveyDetail["MIN-SELECTION"] || this.inputData > this.surveyDetail["MAX-SELECTION"]) && (this.surveyDetail['group'] != "demographics" && this.surveyDetail['group'] != "screener")) {
              this.el.nativeElement.querySelector("#dataVal").classList.add("err_block");
              swal({
                icon: environment.errorIcon,
                buttons: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "custom-button-color",
                    closeModal: true
                  },
                },
                type: "error",
                text: "Response can only be between " + this.surveyDetail["MIN-SELECTION"] + " and " + this.surveyDetail["MAX-SELECTION"] + ".",
              });
              this.showCard = true;
              pass += 1;
            }

            else {
              this.el.nativeElement.querySelector("#dataVal").classList.remove("err_block");
              this.respVar[this.surveyDetail.var] = this.inputData;
            }
          }
          catch {
            pass += 1;
          }
        }
        else {
          this.el.nativeElement.querySelector("#dataVal").classList.remove("err_block");
          this.respVar[this.surveyDetail.var] = this.inputData;
        }
      }

      if (this.inputData == '') {
        this.el.nativeElement.querySelector("#dataVal").classList.add("err_block");
        this.error_text_to_print = "Response is required !";
      }
    }
    else if (this.surveyDetail.qType == "open-end-small" && rowLen > 0) {
      let inputDataRw = this.projectCreation.get("projectpeople").value;
      let nameValue = this.el.nativeElement.querySelector(".getName").name;
      let checkedValue = this.el.nativeElement.querySelector("#notPrefer").checked;
      let notchecked = this.el.nativeElement.querySelector("input.preferNot:not(:checked)");
      let allchecked = this.el.nativeElement.querySelector("input.preferNot:checked");
      let mainErr = 0;
      let reqEr = 0
      let inputNo = parseInt(inputDataRw);

      if (inputDataRw && checkedValue == false) {
        if (inputNo == 0 || inputNo < this.surveyDetail["MIN-SELECTION"] || inputNo > this.surveyDetail["MAX-SELECTION"]) {
          reqEr += 1;
        }
      } else if ((inputDataRw == "" || inputDataRw == null) && checkedValue == false) {
        reqEr += 1;
      }

      if (mainErr == 0 && reqEr == 0) {
        if (checkedValue == true) {
          this.respVar[allchecked.value] = 1;
          this.respVar[nameValue] = "";
        }
        else {
          this.respVar[nameValue] = inputNo;
          this.respVar[notchecked.value] = 0;
        }
      } else {
        if (reqEr > 0) {
          this.error_text_to_print = "Response is required";
        } else {
          this.error_text_to_print = "Response must be between  " + this.surveyDetail["MIN-SELECTION"] + " and " + this.surveyDetail["MAX-SELECTION"];
        }
      }
    }
    else if (this.surveyDetail.qType == "open-end-medium" && rowLen == 0) {
      let respDataMedium = this.el.nativeElement.querySelector("#openEndMedium").value;
      this.openEndMedium = respDataMedium.trim();
      if (this.openEndMedium != '' && this.openEndMedium.length > 2) {
        this.el.nativeElement.querySelector("#openEndMedium").classList.remove("err_block");
        this.respVar[this.surveyDetail.var] = this.openEndMedium;
      }
      else {
        this.el.nativeElement.querySelector("#openEndMedium").classList.add("err_block");
        this.error_text_to_print = "Response is required and should be at least 3 characters";
      }
    }
    else if (this.surveyDetail.qType == "open-end-medium" && rowLen > 0) {
      let respDataMedium = this.el.nativeElement.querySelector("#openEndMedium").value;
      this.openEndMedium = respDataMedium.trim();
      if (this.openEndMedium == "") {
        this.el.nativeElement.querySelector("#openEndMedium").value = "";
      }
      let notcheckedLg = this.el.nativeElement.querySelector("#op_end_md").checked;

      if (notcheckedLg == false && (this.openEndMedium == '' || this.openEndMedium.length <= 2)) {
        if (this.openEndMedium.length <= 2) {
          this.error_text_to_print = "Response is required and should be at least 3 characters";
        } else {
          this.error_text_to_print = "Response is required !";
        }
      }
      else {
        if (this.openEndMedium != '') {
          this.rowResponse.forEach(row => {
            if (row.optionType == "open-end-medium") {
              this.respVar[row.var] = this.openEndMedium;
            } else {
              this.respVar[row.var] = 0;
            }
          });
        }
        else if (this.openEndMedium == '') {
          this.rowResponse.forEach(row => {
            if (row.optionType == "open-end-medium") {
              this.respVar[row.var] = "";
            } else {
              this.respVar[row.var] = 1;
            }
          });
        }
      }
    }
    else if (this.surveyDetail.qType == "open-end-large" && rowLen == 0) {
      let respDataLarge = this.el.nativeElement.querySelector("#opLarge").value;
      this.openEndLarge = respDataLarge.trim();
      if (this.openEndLarge != '' && this.openEndLarge.length > 2) {
        this.respVar[this.surveyDetail.var] = this.openEndLarge;
        this.el.nativeElement.querySelector("#opLarge").classList.remove("err_block");
      }
      else {
        this.error_text_to_print = "Response is required and should be at least 3 characters";
        this.el.nativeElement.querySelector("#opLarge").classList.add("err_block");
      }
    }
    else if (this.surveyDetail.qType == "open-end-large" && rowLen > 0) {
      let respDataLarge = this.el.nativeElement.querySelector("#opLarge").value;
      this.openEndLarge = respDataLarge.trim();
      if (this.openEndLarge == "") {
        this.el.nativeElement.querySelector("#opLarge").value = "";
      }
      let notchecked = this.el.nativeElement.querySelector("#op_end_lg").checked;

      if (notchecked == false && (this.openEndLarge == '' || this.openEndLarge.length <= 2)) {
        if (this.openEndLarge.length <= 2) {
          this.error_text_to_print = "Response is required and should be at least 3 characters";
        } else {
          this.error_text_to_print = "Response is required !";
        }
      }
      else {
        if (this.openEndLarge != '') {
          this.rowResponse.forEach(row => {
            if (row.optionType == "open-end-large") {
              this.respVar[row.var] = this.openEndLarge;
            } else {
              this.respVar[row.var] = 0;
            }
          });
        }
        else if (this.openEndLarge == '') {
          this.rowResponse.forEach(row => {
            if (row.optionType == "open-end-large") {
              this.respVar[row.var] = "";
            } else {
              this.respVar[row.var] = 1;
            }
          });
        }
      }
    }
    else if (this.surveyDetail.qType == "multiple-select") {
      if (rowLen > 0) {
        if (rowLen == 1) {
          if (this.surveyDetail["MAX-SELECTION"] != '' && this.surveyDetail["MAX-SELECTION"] != 0) {
            this.respVar[this.rowResponse[0].var] = this.surveyDetail["MAX-SELECTION"];
          }
        } else {
          let sendResp = 0;
          let minError = 0;
          let maxError = 0;
          let checkedValue = this.el.nativeElement.querySelectorAll("input.multiselect:checked");
          let notchecked = this.el.nativeElement.querySelectorAll("input.multiselect:not(:checked)");

          if (checkedValue.length != 0) {
            checkedValue.forEach(element => {
              let splitData = element.getAttribute("other");
              if (splitData == 1) {
                let other = this.el.nativeElement.querySelector(".oth" + element.value).value.trim();
                if (other == "" || other.length <= 2) {
                  sendResp += 1;
                }
              }
            });

            let dSplit = checkedValue[0].name;
            if (dSplit == 0) {
              if (this.surveyDetail["MIN-SELECTION"]) {
                if (checkedValue.length >= this.surveyDetail["MIN-SELECTION"]) {
                } else {
                  sendResp += 1;
                  minError += 1;
                }
              }
              if (this.surveyDetail["MAX-SELECTION"]) {
                if (checkedValue.length <= this.surveyDetail["MAX-SELECTION"]) {
                } else {
                  sendResp += 1;
                  maxError += 1;
                }
              }
            }

            if (sendResp == 0) {
              checkedValue.forEach(item => {
                let splitData = item.getAttribute("other");
                let other_value = "";
                let name = splitData;
                if (splitData == 1) {
                  other_value = this.el.nativeElement.querySelector(".oth" + item.value).value.trim();
                }

                if (other_value != '' && name == 1) {
                  this.respVar[item.value + "_other"] = other_value;
                  this.respVar[item.value] = 1;
                } else {
                  this.respVar[item.value] = 1;
                }
              });

              if (notchecked.length > 0) {
                notchecked.forEach(item1 => {
                  let splitData = item1.getAttribute("other");
                  if (splitData == 1) {
                    this.respVar[item1.value + "_other"] = "";
                    this.respVar[item1.value] = 0;
                  }
                  else {
                    this.respVar[item1.value] = 0;
                  }
                });
              }
            }
            else {
              if (minError > 0) {
                this.error_text_to_print = "The response must have minimum " + this.surveyDetail["MIN-SELECTION"] + " option selected or should not be blank.";
              }
              else if (maxError > 0) {
                this.error_text_to_print = "Maximum " + this.surveyDetail["MAX-SELECTION"] + " option can be selected";
              }
              else {
                if (sendResp > 0) {
                  this.error_text_to_print = "A response is required and please specify at least 3 characters.";
                }
              }
            }
          } else {
            this.error_text_to_print = "Response is required";
          }
        }
      }
    }
    else if (this.surveyDetail.qType == "single-select") {
      if (rowLen == 1 && rowLen != 0) {
        this.rowResponse.forEach((single, i) => {
          this.el.nativeElement.querySelector("#sin" + i).checked = true;
          this.respVar[single.var] = single.optionCode;
        });
      }
      else {
        let singleDataVal = this.el.nativeElement.querySelectorAll("input.allSingleSelect:checked");
        if (singleDataVal.length != 0) {
          let option_name = singleDataVal[0].name;
          let option_value = singleDataVal[0].value;
          let getOther = singleDataVal[0].getAttribute("getOther");

          if (getOther == 0) {
            this.respVar[option_name] = option_value;
          } else if (getOther == 1) {
            let inputVal = this.el.nativeElement.querySelector(".othSin" + option_name + option_value).value;

            if (inputVal != "" && inputVal.length > 2) {
              let keyVal = option_name + "_" + option_value + "_other";
              this.respVar[keyVal] = inputVal;
              this.respVar[option_name] = option_value;
            }
            else {
              this.error_text_to_print = "Other response is required and must have at least 3 characters.";
            }
          }

        } else {
          this.error_text_to_print = "Response is required";
        }
      }
    }
    else if (this.surveyDetail.qType == "text-filler" || this.surveyDetail.qType == "text-only") {
      this.respVar[this.surveyDetail.var] = 1;
    }
    else if (this.surveyDetail.qType == "grid-row-single-select-carousel") {
      let checkedOptions = this.el.nativeElement.querySelectorAll("input.carusoleOptions:checked");
      if (checkedOptions.length == rowLen) {
        checkedOptions.forEach(row => {
          this.respVar[row.name] = row.value;
        });
      } else {
        this.error_text_to_print = "All options are required !";
      }
    }
    else if (this.surveyDetail.qType == "grid-column-single-select" && (this.surveyDetail.qID == 'q2' || this.surveyDetail.qID == 'Q2')) {
      if (this.checkColOption()) {
        let checkedValue = this.el.nativeElement.querySelectorAll("input.favorite:checked");
        let unchecked = this.el.nativeElement.querySelectorAll("input.favorite:not(:checked)");
        checkedValue.forEach(item => {
          this.respVar[item.name] = item.value;
        });
        if (this.rowList == 1) {
          unchecked.forEach(item => {
            this.respVar[item.name] = 0;
          });
        }
      }
      else {
        let errorBlock = '';
        let regex = /(<([^>]+)>)/ig;
        this.surveyDetail.colOptionList.forEach(item => {
          let thisVar = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
          if (thisVar.length == 0) {
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  errorBlock += err.detail + ", ";
                  break;
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              errorBlock += 'Column' + (item.index + 1);
            }
          } else {
            if (thisVar[0].checked == false) {
              errorBlock += item.optionText + ", ";
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    errorBlock += err.detail + ", ";
                    break;
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                errorBlock += 'Column' + (item.index + 1);
              }
            }
          }
        });
        errorBlock = errorBlock.slice(0, -2);
        errorBlock = errorBlock.replace(regex, "");
        this.error_text_to_print = "Response is required for " + errorBlock;
      }
    }
    else if (this.surveyDetail.qType == "grid-row-single-select") {
      let regex = /(<([^>]+)>)/ig;
      let error_vars = [];
      let errorBlock = "";
      let colOthEr = 0;
      row_arr_no_other.forEach(item => {
        let thisVar = [];
        let thisVar_val_mob = "";
        if (this.getBrowser == true) {
          thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode").value;
        } else if (this.getBrowser == false) {
          thisVar = this.el.nativeElement.querySelectorAll("input.rwGrid_" + item.var + ":checked");
        }

        if (thisVar.length == 0 && thisVar_val_mob == "") {
          let hasStringError = false;
          let hasMediaError = false;
          for (let err of item.optionText) {
            if (err.type == "string") {
              const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
              if (plainText) {
                hasStringError = true;
                let strip = this.stripHtml(err.detail);
                let d1 = strip.trim();
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";

                  break;
                }
              }
            }
            else if (err.type == "image" || err.type == "vedio") {
              hasMediaError = true;
            }
          };
          if (!hasStringError && hasMediaError) {
            let d1 = 'Row' + (item.index + 1);
            if (d1 != "") {
              error_vars.push(d1);
              errorBlock += d1 + ", ";
            }
          }
        }
      });

      let error_vars_other = [];
      row_arr_other.forEach(item => {
        let success = 0;
        let thisVar = [];
        let thisVar_val_mob = "";
        if (this.getBrowser == true) {
          thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode").value;
          let otherMob = this.el.nativeElement.querySelector("#" + item.var + "_otherMob").value.trim();
          if (thisVar_val_mob == "" && otherMob == "") {

          } else {
            if ((thisVar_val_mob == "" && otherMob != "") || (thisVar_val_mob != "" && otherMob == "") || otherMob.length <= 2) {
              if (thisVar_val_mob == "") {
                colOthEr += 1;
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Row' + (item.index + 1);
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              } else {
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars_other.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Row' + (item.index + 1);
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              }
              success += 1;
            }
          }

          if ((otherMob.length <= 2 && thisVar_val_mob != "")) {
            this.el.nativeElement.querySelector("#" + item.var + "_otherMob").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Row' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar_val_mob != "" && otherMob != "" && otherMob.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_otherMob").classList.remove("err_block");
          }
        }
        else if (this.getBrowser == false) {
          thisVar = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
          let ot = this.el.nativeElement.querySelector("#" + item.var + "_other").value.trim();
          if ((thisVar.length == 0 && ot != "") || (thisVar.length > 0 && ot == "")) {
            if (thisVar.length == 0) {
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Row' + (item.index + 1);
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }
          }

          if ((ot.length <= 2 || ot == "") && thisVar.length > 0) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Row' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar.length > 0 && ot != "" && ot.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.remove("err_block");
          }
        }
      });

      if (error_vars.length != 0 || error_vars_other.length != 0 || colOthEr > 0) {
        if (error_vars.length != 0 || colOthEr > 0) {
          errorBlock = error_vars.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Response is required for " + errorBlock;
        }
        else if (error_vars_other.length != 0) {
          errorBlock = error_vars_other.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
        }
      }
      else {
        if (this.getBrowser == true) {
          row_arr_no_other.forEach(item => {
            let thisVar_val_mob = "";
            thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode").value;
            if (thisVar_val_mob != "") {
              this.respVar[item.var] = thisVar_val_mob;
            }
          });
          if (row_arr_other.length > 0) {
            row_arr_other.forEach(item => {
              let thisVar_val_mob = "";
              thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode").value;
              let ot = this.el.nativeElement.querySelector("#" + item.var + "_otherMob").value.trim();
              if (ot != "" && thisVar_val_mob != "") {
                this.respVar[item.var] = thisVar_val_mob;
                this.respVar[item.var + "_other"] = ot;
              } else {
                this.respVar[item.var] = "0";
                this.respVar[item.var + "_other"] = "";
              }
            });
          }
        } else {
          row_arr_no_other.forEach(item => {
            let thisVar_desk = [];
            thisVar_desk = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
            if (thisVar_desk.length != 0) {
              thisVar_desk.forEach(element => {
                this.respVar[element.name] = element.value;
              });
            }
          });

          if (row_arr_other.length > 0) {
            row_arr_other.forEach(item => {
              let thisVar_desk = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
              if (thisVar_desk.length != 0) {
                thisVar_desk.forEach(oth => {
                  let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other").value.trim();
                  this.respVar[oth.name] = oth.value;
                  this.respVar[oth.name + "_other"] = ot;
                });
              } else {
                this.respVar[item.var] = "0";
                this.respVar[item.var + "_other"] = "";
              }
            });
          }
        }
      }
    }
    else if (this.surveyDetail.qType == "grid-column-single-select" && this.surveyDetail.qID != 'q2' && this.surveyDetail.qID != 'Q2') {
      let regex = /(<([^>]+)>)/ig;
      let error_vars = [];
      let errorBlock = "";
      let colOthEr = 0;
      col_arr_no_other.forEach(item => {
        let thisVar = [];
        let thisVar_val_mob = "";
        if (this.getBrowser == true) {
          thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode_col").value;
        }
        else if (this.getBrowser == false) {
          thisVar = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
        }
        if (thisVar.length == 0 && thisVar_val_mob == "") {
          let hasStringError = false;
          let hasMediaError = false;
          for (let err of item.optionText) {
            if (err.type == "string") {
              const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
              if (plainText) {
                hasStringError = true;
                let strip = this.stripHtml(err.detail);
                let d1 = strip.trim();
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                  break;
                }
              }
            }
            else if (err.type == "image" || err.type == "vedio") {
              hasMediaError = true;
            }
          };
          if (!hasStringError && hasMediaError) {
            let d1 = 'Column' + (item.index + 1);
            if (d1 != "") {
              error_vars.push(d1);
              errorBlock += d1 + ", ";
            }
          }
        }
      });

      let error_vars_other = [];
      col_arr_other.forEach(item => {
        let success = 0;
        let thisVar = [];
        let thisVar_val_mob = "";
        if (this.getBrowser == true) {
          thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode_col").value;
          let otherMob = this.el.nativeElement.querySelector("#" + item.var + "_otherMob_col").value.trim();
          if (thisVar_val_mob == "" && otherMob == "") {

          } else {
            if ((thisVar_val_mob == "" && otherMob != "") || (thisVar_val_mob != "" && otherMob == "") || otherMob.length <= 2) {
              if (thisVar_val_mob == "") {
                colOthEr += 1;
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Column' + (item.index + 1);
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              } else {
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars_other.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Column' + (item.index + 1);
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              }
              success += 1;
            }
          }

          if ((otherMob.length <= 2 && thisVar_val_mob != "")) {
            this.el.nativeElement.querySelector("#" + item.var + "_otherMob_col").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Column' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar_val_mob != "" && otherMob != "" && otherMob.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_otherMob_col").classList.remove("err_block");
          }
        }
        else if (this.getBrowser == false) {
          thisVar = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
          let ot = this.el.nativeElement.querySelector("#" + item.var + "_other").value.trim();
          if ((thisVar.length == 0 && ot != "") || (thisVar.length > 0 && ot == "")) {
            if (thisVar.length == 0) {
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Column' + (item.index + 1);
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }
          }

          if ((ot.length <= 2 || ot == "") && thisVar.length > 0) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Column' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar.length > 0 && ot != "" && ot.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.remove("err_block");
          }
        }
      });

      if (error_vars.length != 0 || error_vars_other.length != 0 || colOthEr > 0) {
        if (error_vars.length != 0 || colOthEr > 0) {
          errorBlock = error_vars.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Response is required for " + errorBlock;
        }
        else if (error_vars_other.length != 0) {
          errorBlock = error_vars_other.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
        }
      }
      else {
        if (this.getBrowser == true) {
          col_arr_no_other.forEach(item => {
            let thisVar_val_mob = "";
            thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode_col").value;
            if (thisVar_val_mob != "") {
              this.respVar[item.var] = thisVar_val_mob;
            }
          });
          if (col_arr_other.length > 0) {
            col_arr_other.forEach(item => {
              let thisVar_val_mob = "";
              thisVar_val_mob = this.el.nativeElement.querySelector("#" + item.var + "_opCode_col").value;
              let ot = this.el.nativeElement.querySelector("#" + item.var + "_otherMob_col").value.trim();
              if (ot != "" && thisVar_val_mob != "") {
                this.respVar[item.var] = thisVar_val_mob;
                this.respVar[item.var + "_other"] = ot;
              } else {
                this.respVar[item.var] = "0";
                this.respVar[item.var + "_other"] = "";
              }
            });
          }
        } else {
          col_arr_no_other.forEach(item => {
            let thisVar_desk = [];
            thisVar_desk = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
            if (thisVar_desk.length != 0) {
              thisVar_desk.forEach(element => {
                this.respVar[element.name] = element.value;
              });
            }
          });

          if (col_arr_other.length > 0) {
            col_arr_other.forEach(item => {
              let thisVar_desk = this.el.nativeElement.querySelectorAll("input[name='" + item.var + "']:checked");
              if (thisVar_desk.length != 0) {
                thisVar_desk.forEach(oth => {
                  let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other").value.trim();
                  this.respVar[oth.name] = oth.value;
                  this.respVar[oth.name + "_other"] = ot;
                });
              } else {
                this.respVar[item.var] = "0";
                this.respVar[item.var + "_other"] = "";
              }
            });
          }
        }
      }
    }
    else if (this.surveyDetail.qType == "grid-row-multiple-select") {
      let regex = /(<([^>]+)>)/ig;
      let error_vars = [];
      let error_vars_other = [];
      let errorBlock = "";
      let othrErrMain = 0;
      row_arr_no_other.forEach(item => {
        let thisVar = [];
        if (this.getBrowser == true) {
          thisVar = this.el.nativeElement.querySelectorAll("input.mob_" + item.var + ":checked");
        } else if (this.getBrowser == false) {
          thisVar = this.el.nativeElement.querySelectorAll("input.desk_" + item.var + ":checked");
        }
        if (thisVar.length == 0) {
          let hasStringError = false;
          let hasMediaError = false;
          for (let err of item.optionText) {
            if (err.type == "string") {
              const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
              if (plainText) {
                hasStringError = true;
                let strip = this.stripHtml(err.detail);
                let d1 = strip.trim();
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                  break;
                }
              }
            }
            else if (err.type == "image" || err.type == "vedio") {
              hasMediaError = true;
            }
          };
          if (!hasStringError && hasMediaError) {
            let d1 = 'Row' + (item.index + 1);
            if (d1 != "") {
              error_vars.push(d1);
              errorBlock += d1 + ", ";
            }
          }
        }
      });

      row_arr_other.forEach(item => {
        if (this.getBrowser == true) {
          let oth = this.el.nativeElement.querySelector("#" + item.var + "_other_mob").value.trim();
          let thisVar_val_mob = [];
          thisVar_val_mob = this.el.nativeElement.querySelectorAll("input.mob_" + item.var + ":checked");
          if (oth == "" && thisVar_val_mob.length == 0) {

          } else {
            if ((thisVar_val_mob.length == 0 && oth != "") || (thisVar_val_mob.length != 0 && oth == "")) {
              if (thisVar_val_mob.length == 0) {
                othrErrMain += 1;
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Row' + (item.index + 1);
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              }
            }
          }

          if ((oth.length <= 2 && thisVar_val_mob.length > 0)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other_mob").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Row' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar_val_mob.length > 0 && oth != "" && oth.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other_mob").classList.remove("err_block");
          }

        }
        else if (this.getBrowser == false) {
          let thisVar = [];
          thisVar = this.el.nativeElement.querySelectorAll("input.desk_" + item.var + ":checked");
          let ot = this.el.nativeElement.querySelector("#" + item.var + "_other").value.trim();
          if ((thisVar.length == 0 && ot != "") || (thisVar.length > 0 && ot == "")) {
            if (thisVar.length == 0) {
              othrErrMain += 1;
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Row' + (item.index + 1);
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
          }

          if ((ot.length <= 2 && thisVar.length > 0)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Row' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar.length > 0 && ot != "" && ot.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.remove("err_block");
          }
        }
      });

      if (error_vars.length != 0 || error_vars_other.length != 0 || othrErrMain > 0) {
        if (error_vars.length != 0 || othrErrMain > 0) {
          errorBlock = error_vars.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Response is required for " + errorBlock;
        }
        else if (error_vars_other.length != 0) {
          errorBlock = error_vars_other.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
        }
      }
      else {
        row_arr_no_other.forEach(item => {
          if (this.getBrowser == true) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.mob_" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(element => {
                let get_send_id = element.getAttribute('sendId');
                this.respVar[get_send_id] = "1";
              });
            }
          } else if (this.getBrowser == false) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.desk_" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(element => {
                let get_send_id = element.getAttribute('sendId');
                this.respVar[get_send_id] = "1";
              });
            }
          }
        });

        row_arr_other.forEach(item => {
          if (this.getBrowser == true) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.mob_" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(oth => {
                let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other_mob").value.trim();
                let get_send_id = oth.getAttribute('sendId');
                this.respVar[get_send_id] = oth.value;
                this.respVar[oth.name + "_other"] = ot;
              });
            }
          } else if (this.getBrowser == false) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.desk_" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(oth => {
                let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other").value.trim();
                let get_send_id = oth.getAttribute('sendId');
                this.respVar[get_send_id] = oth.value;
                this.respVar[oth.name + "_other"] = ot;
              });
            }
          }
        });

        let notcheckedGridMultiple = [];
        if (this.getBrowser == true) {
          notcheckedGridMultiple = this.el.nativeElement.querySelectorAll(".rowUnchecked:not(:checked)");
          if (notcheckedGridMultiple) {
            notcheckedGridMultiple.forEach(item5 => {
              let thisVar = [];
              if (this.getBrowser == true) {
                thisVar = this.el.nativeElement.querySelectorAll("input.mob_" + item5.name + ":checked");
              }

              let get_send_id = item5.getAttribute('sendId');
              if (item5.value == 1) {
                if (thisVar.length > 0) {
                  this.respVar[get_send_id] = "0";
                } else {
                  this.respVar[get_send_id] = "0";
                  this.respVar[item5.name + "_other"] = "";
                }
              } else {
                this.respVar[get_send_id] = "0";
              }
            });
          }
        } else if (this.getBrowser == false) {
          notcheckedGridMultiple = this.el.nativeElement.querySelectorAll("input.gridCheckMultipleDesk:not(:checked)");
          if (notcheckedGridMultiple) {
            notcheckedGridMultiple.forEach(item5 => {
              let thisVar = [];
              if (this.getBrowser == false) {
                thisVar = this.el.nativeElement.querySelectorAll("input.desk_" + item5.name + ":checked");
              }
              let get_send_id = item5.getAttribute('sendId');
              if (item5.value == 1) {
                if (thisVar.length > 0) {
                  this.respVar[get_send_id] = "0";
                } else {
                  this.respVar[get_send_id] = "0";
                  this.respVar[item5.name + "_other"] = "";
                }
              } else {
                this.respVar[get_send_id] = "0";
              }
            });
          }
        }
      }
    }
    else if (this.surveyDetail.qType == "grid-column-multiple-select" && this.surveyDetail['MAX-SELECTION'] == 0 && this.surveyDetail['MIN-SELECTION'] == 0) {
      let regex = /(<([^>]+)>)/ig;
      let error_vars = [];
      let error_vars_other = [];
      let errorBlock = "";
      let othrErrMain = 0;
      col_arr_no_other.forEach(item => {
        let thisVar = [];
        if (this.getBrowser == true) {
          thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
        } else if (this.getBrowser == false) {
          thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
        }
        if (thisVar.length == 0) {
          let hasStringError = false;
          let hasMediaError = false;
          for (let err of item.optionText) {
            if (err.type == "string") {
              const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
              if (plainText) {
                hasStringError = true;
                let strip = this.stripHtml(err.detail);
                let d1 = strip.trim();
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                  break;
                }
              }
            }
            else if (err.type == "image" || err.type == "vedio") {
              hasMediaError = true;
            }
          };
          if (!hasStringError && hasMediaError) {
            let d1 = 'Column' + (item.index + 1);
            if (d1 != "") {
              error_vars.push(d1);
              errorBlock += d1 + ", ";
            }
          }
        }
      });

      col_arr_other.forEach(item => {
        if (this.getBrowser == true) {
          let oth = this.el.nativeElement.querySelector("#" + item.var + "_other_mob").value.trim();
          let thisVar_val_mob = [];
          thisVar_val_mob = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
          if (oth == "" && thisVar_val_mob.length == 0) {

          } else {
            if ((thisVar_val_mob.length == 0 && oth != "") || (thisVar_val_mob.length != 0 && oth == "")) {
              if (thisVar_val_mob.length == 0) {
                othrErrMain += 1;
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Column' + (item.index + 1);
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              }
            }
          }

          if ((oth.length <= 2 && thisVar_val_mob.length > 0)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other_mob").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Column' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar_val_mob.length > 0 && oth != "" && oth.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other_mob").classList.remove("err_block");
          }
        } else if (this.getBrowser == false) {
          let thisVar = [];
          thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
          let ot = this.el.nativeElement.querySelector("#" + item.var + "_other").value.trim();
          if ((thisVar.length == 0 && ot != "") || (thisVar.length > 0 && ot == "")) {
            if (thisVar.length == 0) {
              othrErrMain += 1;
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Column' + (item.index + 1);
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
          }

          if ((ot.length <= 2 && thisVar.length > 0)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars_other.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Column' + (item.index + 1);
              if (d1 != "") {
                error_vars_other.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }

          if ((thisVar.length > 0 && ot != "" && ot.length > 2)) {
            this.el.nativeElement.querySelector("#" + item.var + "_other").classList.remove("err_block");
          }
        }
      });

      if (error_vars.length != 0 || error_vars_other.length != 0 || othrErrMain > 0) {
        if (error_vars.length != 0 || othrErrMain > 0) {
          errorBlock = error_vars.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Response is required for " + errorBlock;
        }
        else if (error_vars_other.length != 0) {
          errorBlock = error_vars_other.join(", ");
          // errorBlock = errorBlock.replace(regex, "");
          this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
        }
      }
      else {
        col_arr_no_other.forEach(item => {
          if (this.getBrowser == true) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(element => {
                let get_send_id = element.getAttribute('sendId');
                this.respVar[get_send_id] = "1";
              });
            }
          } else if (this.getBrowser == false) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(element => {
                let get_send_id = element.getAttribute('sendId');
                this.respVar[get_send_id] = "1";
              });
            }
          }
        });

        col_arr_other.forEach(item => {
          if (this.getBrowser == true) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(oth => {
                let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other_mob").value.trim();
                let get_send_id = oth.getAttribute('sendId');
                this.respVar[get_send_id] = oth.value;
                this.respVar[oth.name + "_other"] = ot;
              });
            }
          } else if (this.getBrowser == false) {
            let thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
            if (thisVar.length != 0) {
              thisVar.forEach(oth => {
                let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other").value.trim();
                let get_send_id = oth.getAttribute('sendId');
                this.respVar[get_send_id] = oth.value;
                this.respVar[oth.name + "_other"] = ot;
              });
            }
          }
        });

        let notcheckedGridMultiple = [];
        if (this.getBrowser == true) {
          notcheckedGridMultiple = this.el.nativeElement.querySelectorAll(".uncheckedData:not(:checked)");
          if (notcheckedGridMultiple) {
            notcheckedGridMultiple.forEach(item5 => {
              let thisVar = [];
              if (this.getBrowser == true) {
                thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item5.name + ":checked");
              }
              let get_send_id = item5.getAttribute('sendId');
              if (item5.value == 1) {
                if (thisVar.length > 0) {
                  this.respVar[get_send_id] = "0";
                } else {
                  this.respVar[get_send_id] = "0";
                  this.respVar[item5.name + "_other"] = "";
                }
              } else {
                this.respVar[get_send_id] = "0";
              }
            });
          }
        }
        else if (this.getBrowser == false) {
          notcheckedGridMultiple = this.el.nativeElement.querySelectorAll("input.gridCheckMultipleColDesk:not(:checked)");
          if (notcheckedGridMultiple) {
            notcheckedGridMultiple.forEach(item5 => {
              let thisVar = [];
              if (this.getBrowser == false) {
                thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item5.name + ":checked");
              }
              let get_send_id = item5.getAttribute('sendId');
              if (item5.value == 1) {
                if (thisVar.length > 0) {
                  this.respVar[get_send_id] = "0";
                } else {
                  this.respVar[get_send_id] = "0";
                  this.respVar[item5.name + "_other"] = "";
                }
              } else {
                this.respVar[get_send_id] = "0";
              }
            });
          }
        }

      }
    }
    else if (this.surveyDetail.qType == "grid-column-multiple-select" && (((this.surveyDetail['MAX-SELECTION'] > 0 && this.surveyDetail['MIN-SELECTION'] > 0)) || ((this.surveyDetail['MAX-SELECTION'] > 0 || this.surveyDetail['MIN-SELECTION'] == 0)))) {
      let result = this.checkMinMaxForMultipleColumn();
      if (result.length == 0) {
        let regex = /(<([^>]+)>)/ig;
        let error_vars = [];
        let error_vars_other = [];
        let errorBlock = "";
        let othrErrMain = 0;
        col_arr_no_other.forEach(item => {
          let thisVar = [];
          if (this.getBrowser == true) {
            thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
          } else if (this.getBrowser == false) {
            thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
          }
          if (thisVar.length == 0) {
            let hasStringError = false;
            let hasMediaError = false;
            for (let err of item.optionText) {
              if (err.type == "string") {
                const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                if (plainText) {
                  hasStringError = true;
                  let strip = this.stripHtml(err.detail);
                  let d1 = strip.trim();
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                    break;
                  }
                }
              }
              else if (err.type == "image" || err.type == "vedio") {
                hasMediaError = true;
              }
            };
            if (!hasStringError && hasMediaError) {
              let d1 = 'Column' + (item.index + 1);
              if (d1 != "") {
                error_vars.push(d1);
                errorBlock += d1 + ", ";
              }
            }
          }
        });

        col_arr_other.forEach(item => {
          if (this.getBrowser == true) {
            let oth = this.el.nativeElement.querySelector("#" + item.var + "_other_mob").value.trim();
            let thisVar_val_mob = [];
            thisVar_val_mob = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
            if (oth == "" && thisVar_val_mob.length == 0) {

            } else {
              if ((thisVar_val_mob.length == 0 && oth != "") || (thisVar_val_mob.length != 0 && oth == "")) {
                if (thisVar_val_mob.length == 0) {
                  othrErrMain += 1;
                  let hasStringError = false;
                  let hasMediaError = false;
                  for (let err of item.optionText) {
                    if (err.type == "string") {
                      const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                      if (plainText) {
                        hasStringError = true;
                        let strip = this.stripHtml(err.detail);
                        let d1 = strip.trim();
                        if (d1 != "") {
                          error_vars.push(d1);
                          errorBlock += d1 + ", ";
                          break;
                        }
                      }
                    }
                    else if (err.type == "image" || err.type == "vedio") {
                      hasMediaError = true;
                    }
                  };
                  if (!hasStringError && hasMediaError) {
                    let d1 = 'Column' + (item.index + 1);
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                    }
                  }
                }
              }
            }

            if ((oth.length <= 2 && thisVar_val_mob.length > 0)) {
              this.el.nativeElement.querySelector("#" + item.var + "_other_mob").classList.add("err_block");
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars_other.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Column' + (item.index + 1);
                if (d1 != "") {
                  error_vars_other.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }

            if ((thisVar_val_mob.length > 0 && oth != "" && oth.length > 2)) {
              this.el.nativeElement.querySelector("#" + item.var + "_other_mob").classList.remove("err_block");
            }
          } else if (this.getBrowser == false) {
            let thisVar = [];
            thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
            let ot = this.el.nativeElement.querySelector("#" + item.var + "_other").value.trim();
            if ((thisVar.length == 0 && ot != "") || (thisVar.length > 0 && ot == "")) {
              if (thisVar.length == 0) {
                othrErrMain += 1;
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Column' + (item.index + 1);
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              }
              this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
            }

            if ((ot.length <= 2 && thisVar.length > 0)) {
              this.el.nativeElement.querySelector("#" + item.var + "_other").classList.add("err_block");
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars_other.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Column' + (item.index + 1);
                if (d1 != "") {
                  error_vars_other.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }

            if ((thisVar.length > 0 && ot != "" && ot.length > 2)) {
              this.el.nativeElement.querySelector("#" + item.var + "_other").classList.remove("err_block");
            }
          }
        });

        if (error_vars.length != 0 || error_vars_other.length != 0 || othrErrMain > 0) {
          if (error_vars.length != 0 || othrErrMain > 0) {
            errorBlock = error_vars.join(", ");
            // errorBlock = errorBlock.replace(regex, "");
            this.error_text_to_print = "Response is required for " + errorBlock;
          }
          else if (error_vars_other.length != 0) {
            errorBlock = error_vars_other.join(", ");
            // errorBlock = errorBlock.replace(regex, "");
            this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
          }
        }
        else {
          col_arr_no_other.forEach(item => {
            if (this.getBrowser == true) {
              let thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
              if (thisVar.length != 0) {
                thisVar.forEach(element => {
                  let get_send_id = element.getAttribute('sendId');
                  this.respVar[get_send_id] = "1";
                });
              }
            } else if (this.getBrowser == false) {
              let thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
              if (thisVar.length != 0) {
                thisVar.forEach(element => {
                  let get_send_id = element.getAttribute('sendId');
                  this.respVar[get_send_id] = "1";
                });
              }
            }
          });

          col_arr_other.forEach(item => {
            if (this.getBrowser == true) {
              let thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item.var + ":checked");
              if (thisVar.length != 0) {
                thisVar.forEach(oth => {
                  let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other_mob").value.trim();
                  let get_send_id = oth.getAttribute('sendId');
                  this.respVar[get_send_id] = oth.value;
                  this.respVar[oth.name + "_other"] = ot;
                });
              }
            } else if (this.getBrowser == false) {
              let thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item.var + ":checked");
              if (thisVar.length != 0) {
                thisVar.forEach(oth => {
                  let ot = this.el.nativeElement.querySelector("#" + oth.name + "_other").value.trim();
                  let get_send_id = oth.getAttribute('sendId');
                  this.respVar[get_send_id] = oth.value;
                  this.respVar[oth.name + "_other"] = ot;
                });
              }
            }
          });

          let notcheckedGridMultiple = [];
          if (this.getBrowser == true) {
            notcheckedGridMultiple = this.el.nativeElement.querySelectorAll(".uncheckedData:not(:checked)");
            if (notcheckedGridMultiple) {
              notcheckedGridMultiple.forEach(item5 => {
                let thisVar = [];
                if (this.getBrowser == true) {
                  thisVar = this.el.nativeElement.querySelectorAll("input.mob_col" + item5.name + ":checked");
                }
                let get_send_id = item5.getAttribute('sendId');
                if (item5.value == 1) {
                  if (thisVar.length > 0) {
                    this.respVar[get_send_id] = "0";
                  } else {
                    this.respVar[get_send_id] = "0";
                    this.respVar[item5.name + "_other"] = "";
                  }
                } else {
                  this.respVar[get_send_id] = "0";
                }
              });
            }
          }
          else if (this.getBrowser == false) {
            notcheckedGridMultiple = this.el.nativeElement.querySelectorAll("input.gridCheckMultipleColDesk:not(:checked)");
            if (notcheckedGridMultiple) {
              notcheckedGridMultiple.forEach(item5 => {
                let thisVar = [];
                if (this.getBrowser == false) {
                  thisVar = this.el.nativeElement.querySelectorAll("input.desk_col" + item5.name + ":checked");
                }
                let get_send_id = item5.getAttribute('sendId');
                if (item5.value == 1) {
                  if (thisVar.length > 0) {
                    this.respVar[get_send_id] = "0";
                  } else {
                    this.respVar[get_send_id] = "0";
                    this.respVar[item5.name + "_other"] = "";
                  }
                } else {
                  this.respVar[get_send_id] = "0";
                }
              });
            }
          }

        }
      }
      else {
        let str = "";
        result.forEach((row, j) => {
          row.forEach(res => {
            if (res.type == "string") {
              if (j == 0) {
                str += this.stripHtml(res.detail);
              }
              else {
                str += ", " + this.stripHtml(res.detail);
              }
            }
          });
        });
        this.error_text_to_print = "Minimum selection should be " + this.surveyDetail['MIN-SELECTION'] + " and maximum selection should be " + this.surveyDetail['MAX-SELECTION'] + " for " + str;
      }
    }
    else if (this.surveyDetail.qType == "drag-n-drop-ranking") {
      if (this.rowResponse.length > 0 && this.show == 'show') {
        this.rowResponse.forEach((col, i) => {
          let id = this.el.nativeElement.querySelector("#" + this.rowResponse[i].var).id;
          let value = this.el.nativeElement.querySelector("#" + this.rowResponse[i].var).value;
          this.respVar[id] = value;
        });
      }
      else {
        this.rowResponse.forEach((col, i) => {
          let showData = this.setData[this.rowResponse[i].var];
          if (showData != null && showData != '') {
            this.respVar[this.rowResponse[i].var] = showData;
          } else {
            this.error_text_to_print = "Please rank atleast one item";
          }
        });
      }
    }
    else if (this.surveyDetail.qType == "ranking") {
      if (this.rowResponse.length > 0) {
        let rankEx = this.el.nativeElement.querySelectorAll(".rankExcl:checked");
        if (rankEx.length > 0) {
          this.surveyDetail.rowOptionList.forEach(rankRsp => {
            if (rankRsp.other == 1) {
              this.respVar[rankRsp.var + "_other"] = "";
              this.respVar[rankRsp.var] = 0;
            } else {
              if (rankRsp.exclusive == 1) {
                this.respVar[rankRsp.var] = 1;
              } else {
                this.respVar[rankRsp.var] = 0;
              }
            }
          });
        } else {
          let totalRank = this.el.nativeElement.querySelectorAll(".getAllRank");
          // let getAllOtherRank = this.el.nativeElement.querySelectorAll(".getAllOtherRank");
          let array = [];
          let otherErr = 0;
          let minMaxCounter = 0;
          let error_vars = [];
          let errorBlock = "";
          let regex = /(<([^>]+)>)/ig;

          this.rowResponse.forEach(othr => {
            if (othr.exclusive == 0) {
              let sumVal = this.el.nativeElement.querySelector("#" + othr.var).value.trim();
              if (sumVal != "") {
                minMaxCounter += 1;
              }
              if (othr.other == 1) {
                let oth = this.el.nativeElement.querySelector("#" + othr.var + "_other").value.trim();
                if (sumVal == "" && oth == "") {

                } else {
                  if ((sumVal == "" && oth != "") || (oth == "" && sumVal != "") || oth.length <= 2) {
                    if (oth == "" || oth.length <= 2) {
                      otherErr += 1;
                    } else {
                      othr.optionText.forEach(err => {
                        if (err.type == "string") {
                          let strip = this.stripHtml(err.detail);
                          let d1 = strip.trim();
                          if (d1 != "") {
                            error_vars.push(d1);
                            errorBlock += d1 + ", ";
                          }
                        }
                      });
                    }
                  }
                }
              }
            }
          });

          if (error_vars.length == 0 && otherErr == 0 && minMaxCounter >= this.surveyDetail["MIN-SELECTION"] && minMaxCounter <= this.surveyDetail["MAX-SELECTION"]) {
            totalRank.forEach(element => {
              let temp = {};
              if (element.value != '' && element.value != 0) {
                temp["elem_id"] = element.id;
                temp["valyu"] = element.value;
                array.push(temp);
              }
            });

            let distinctArray = array.map(item => item.valyu)
              .filter((value, index, self) => self.indexOf(value) === index);
            let counter = 0;
            let missingRank;
            let finalVal = [];

            if (distinctArray.length == minMaxCounter) {
              totalRank.forEach((col, i) => {
                if (totalRank[i].value != '' && totalRank[i].value != 0 && totalRank[i].value <= minMaxCounter && totalRank[i].id != '') {
                  counter += 1;
                  finalVal.push(totalRank[i].value);
                }
              });

              if (counter == minMaxCounter) {
                let exlcRank = this.el.nativeElement.querySelectorAll(".rankExcl");
                if (exlcRank.length > 0) {
                  exlcRank.forEach(rk => {
                    this.respVar[rk.value] = 0;
                  });
                }

                totalRank.forEach(ele => {
                  let otherExl = parseInt(ele.getAttribute('dataType'));
                  let valEl = "0";
                  if (ele.value != "") {
                    valEl = ele.value
                  }
                  if (otherExl == 1) {
                    let oth = this.el.nativeElement.querySelector("#" + ele.id + "_other").value.trim();
                    this.respVar[ele.id + "_other"] = oth;
                    this.respVar[ele.id] = valEl;
                  } else {
                    this.respVar[ele.id] = valEl;
                  }
                });

              } else {
                let count = 1;
                finalVal.sort(function (a, b) { return a - b });
                for (let i = 0; i < minMaxCounter; i++) {
                  if (finalVal.length >= i) {
                    if (count != finalVal[i]) {
                      missingRank = count;
                      break;
                    }
                  }
                  else {
                    missingRank = count;
                    break;
                  }
                  count++;
                }
                if (otherErr == 0) {
                  this.error_text_to_print = "Rank " + missingRank + " is missing";
                } else {
                  this.error_text_to_print = "Other response is required.";
                }
              }
            } else {
              this.error_text_to_print = "Ranks should be unique and not 0/empty";
            }
          } else {
            if (otherErr == 0 && (minMaxCounter == 0 || minMaxCounter < this.surveyDetail["MIN-SELECTION"] || minMaxCounter > this.surveyDetail["MAX-SELECTION"])) {
              this.error_text_to_print = "Please rank at least " + this.surveyDetail["MIN-SELECTION"] + " items and at most " + this.surveyDetail["MAX-SELECTION"] + " items.";
            } else if (otherErr > 0) {
              this.error_text_to_print = "Other response is required and should be at least 3 characters";
            }
            else if (error_vars.length != 0) {
              errorBlock = error_vars.join(", ");
              errorBlock = errorBlock.replace(regex, "");
              this.error_text_to_print = "Response is required for " + errorBlock;
            }
            else {
              this.error_text_to_print = "Ranks should be unique and not 0/empty";
            }
          }

        }
      }
    }
    else if (this.surveyDetail.qType == "sum-upto-n") {
      if (this.rowResponse.length > 0) {
        if (this.rowResponse.length == 1) {
          if (this.surveyDetail["MAX-SELECTION"] != '' || this.surveyDetail["MAX-SELECTION"] != 0) {
            this.respVar[this.rowResponse[0].var] = this.surveyDetail["MAX-SELECTION"];
          } else {
            this.respVar[this.rowResponse[0].var] = 100;
          }
        } else {
          let totalSumVal = this.el.nativeElement.querySelector("#totalData").value;
          let sumVal = this.surveyDetail["MAX-SELECTION"];
          if (sumVal == '' || sumVal == 0) {
            sumVal = 100;
          }
          let otherError = 0
          let sumError = 0
          let error_vars_other = [];
          let error_vars = [];
          let errorBlock = "";
          let excl = this.el.nativeElement.querySelectorAll(".getAllExcl:checked");
          let regex = /(<([^>]+)>)/ig;

          if (excl.length > 0) {
            excl.forEach(ex => {
              let otherExl = ex.getAttribute('dataother');
              if (ex.value == 1) {
                this.respVar[otherExl] = 1;
              }
            });
            this.rowResponse.forEach(exl => {
              if (exl.other == 1) {
                this.respVar[exl.var + "_other"] = "";
                this.respVar[exl.var] = 0;
              } else {
                if (exl.exclusive == 0) {
                  this.respVar[exl.var] = 0;
                }
              }
            });
          } else {
            let perRowError = 0;
            row_arr_no_other.forEach(item => {
              if (item.exclusive == 0) {
                let thisVar = this.el.nativeElement.querySelector("#sumUp" + item.var).value.trim();
                let sumVal = parseInt(thisVar);
                if (thisVar == "" && (totalSumVal < this.numericMin || totalSumVal > this.numericMax)) {
                  let hasStringError = false;
                  let hasMediaError = false;
                  for (let err of item.optionText) {
                    if (err.type == "string") {
                      const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                      if (plainText) {
                        hasStringError = true;
                        let strip = this.stripHtml(err.detail);
                        let d1 = strip.trim();
                        if (d1 != "") {
                          error_vars.push(d1);
                          errorBlock += d1 + ", ";
                          break;
                        }
                      }
                    }
                    else if (err.type == "image" || err.type == "vedio") {
                      hasMediaError = true;
                    }
                  };
                  if (!hasStringError && hasMediaError) {
                    let d1 = 'Row' + (item.index + 1);
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                    }
                  }
                  perRowError += 1;
                }

                if (thisVar != "") {
                  let sumVal = parseInt(thisVar);
                  if (sumVal >= this.numericMin && sumVal <= this.numericMax) {

                  } else {
                    perRowError += 1;
                  }
                }
              }
            });

            row_arr_other.forEach(item => {
              if (item.other == 1) {
                let thisVar = this.el.nativeElement.querySelector("#sumUp" + item.var).value.trim();
                let ot = this.el.nativeElement.querySelector("#" + item.var + "_other").value.trim();
                if (thisVar == "" && ot == "") {

                } else {
                  if (((thisVar == "" && ot != '') || (thisVar != '' && ot == "") || (thisVar != '' && ot != "" && ot.length <= 2)) && item.exclusive == 0) {
                    if (ot == "" || ot.length <= 2) {
                      let hasMediaError = false;
                      let hasStringError = false;
                      for (let err of item.optionText) {
                        const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                        if (plainText) {
                          hasStringError = true;
                          if (err.type == "string") {
                            let strip = this.stripHtml(err.detail);
                            let d1 = strip.trim();
                            if (d1 != "") {
                              error_vars_other.push(d1);
                              errorBlock += d1 + ", ";
                              break;
                            }
                          }
                        }
                        else if (err.type == "image" || err.type == "vedio") {
                          hasMediaError = true;
                        }
                      };
                      if (!hasStringError && hasMediaError) {
                        let d1 = 'Row' + (item.index + 1);
                        if (d1 != "") {
                          error_vars_other.push(d1);
                          errorBlock += d1 + ", ";
                        }
                      }
                    } else {
                      let hasMediaError = false;
                      let hasStringError = false;
                      for (let err of item.optionText) {
                        if (err.type == "string") {
                          const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                          if (plainText) {
                            hasStringError = true;
                            let strip = this.stripHtml(err.detail);
                            let d1 = strip.trim();
                            if (d1 != "") {
                              error_vars.push(d1);
                              errorBlock += d1 + ", ";
                              break;
                            }
                          }
                        }
                        else if (err.type == "image" || err.type == "vedio") {
                          hasMediaError = true;
                        }
                      };
                      if (!hasStringError && hasMediaError) {
                        let d1 = 'Row' + (item.index + 1);
                        if (d1 != "") {
                          error_vars.push(d1);
                          errorBlock += d1 + ", ";
                        }
                      }
                    }
                  }
                }

                if (thisVar != "") {
                  let sumVal = parseInt(thisVar);
                  if (sumVal >= this.numericMin && sumVal <= this.numericMax) {

                  } else {
                    perRowError += 1;
                  }
                }
              }
            });


            if (totalSumVal != sumVal || error_vars.length != 0 || error_vars_other.length != 0 || perRowError > 0) {
              if (totalSumVal != sumVal) {
                this.error_text_to_print = "Total sum must be " + this.numericMax;
              } else {
                if (error_vars_other.length > 0) {
                  errorBlock = error_vars_other.join(", ");
                  // errorBlock = errorBlock.replace(regex, "");
                  this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
                } else {
                  if (perRowError > 0) {
                    this.error_text_to_print = "Minimum value required for each option is " + this.numericMin + " and maximum value is " + this.numericMax + ".";
                  } else {
                    if (error_vars.length != 0) {
                      errorBlock = error_vars.join(", ");
                      // errorBlock = errorBlock.replace(regex, "");
                      this.error_text_to_print = "Response is required for " + errorBlock + " and total sum must be " + this.numericMax;
                    }
                  }
                }
              }
            } else {
              this.rowResponse.forEach(row => {
                if (row.exclusive == 1) {
                  this.respVar[row.var] = 0;
                } else {
                  let valueData = this.el.nativeElement.querySelector("#sumUp" + row.var).value;
                  if (valueData == "") {
                    valueData = 0;
                  }

                  if (row.other == 1) {
                    let othData = this.el.nativeElement.querySelector("#" + row.var + "_other").value.trim();
                    this.respVar[row.var + "_other"] = othData;
                    this.respVar[row.var] = valueData;
                  } else {
                    this.respVar[row.var] = valueData;
                  }
                }
              });
            }
          }
        }
      }
    }
    else if (this.surveyDetail.qType == "single-select-horizontal-grid") {
      if (rowLen > 0) {
        let horizontalCheck = this.el.nativeElement.querySelectorAll("input.horizontalCheck:checked");
        if (horizontalCheck.length > 0) {
          horizontalCheck.forEach(horizontal => {
            this.respVar[this.surveyDetail.var] = horizontal.value;
          });
        } else {
          this.error_text_to_print = "Response is required";
        }
      }
    }
    else if (this.surveyDetail.qType == "numeric-row-list") {
      if (this.rowResponse.length > 0) {
        let regex = /(<([^>]+)>)/ig;
        let error_vars = [];
        let errorBlock = "";
        let numCheck = this.el.nativeElement.querySelector("input.numCheck:checked");
        let numCheckNot = this.el.nativeElement.querySelector("input.numCheck:not(:checked)");
        let getAllNum = this.el.nativeElement.querySelectorAll(".getAllNumvalue");

        if (numCheck) {
          this.respVar[numCheck.value] = 1;
          getAllNum.forEach(num => {
            let oth = num.getAttribute('dataother');
            if (oth == 0) {
              this.respVar[num.name] = 0;
            } else {
              this.respVar[num.name] = 0;
              let otherEl = this.el.nativeElement.querySelector("#" + num.name + "_other");
              this.respVar[num.name + "_other"] = otherEl ? otherEl.value.trim() : "";
            }
          });
        }
        else {
          let perRowError = 0;
          row_arr_no_other.forEach(item => {
            if (item.exclusive == 0) {
              let numInput = this.el.nativeElement.querySelector("#numUp" + item.var);
              let thisVar = numInput ? numInput.value.trim() : "";
              if (thisVar == "") {
                let hasStringError = false;
                let hasMediaError = false;
                for (let err of item.optionText) {
                  if (err.type == "string") {
                    const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                    if (plainText) {
                      hasStringError = true;
                      let strip = this.stripHtml(err.detail);
                      let d1 = strip.trim();
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                        break;
                      }
                    }
                  }
                  else if (err.type == "image" || err.type == "vedio") {
                    hasMediaError = true;
                  }
                };
                if (!hasStringError && hasMediaError) {
                  let d1 = 'Row' + (item.index + 1);
                  if (d1 != "") {
                    error_vars.push(d1);
                    errorBlock += d1 + ", ";
                  }
                }
              }
              if (thisVar != "") {
                let sumVal = parseInt(thisVar);
                if (sumVal >= this.numericMin && sumVal <= this.numericMax) {

                } else {
                  perRowError += 1;
                }
              }
            }
          });

          let error_vars_other = [];
          let othrErr = 0;
          row_arr_other.forEach(item => {
            if (item.other == 1) {
              let numInput = this.el.nativeElement.querySelector("#numUp" + item.var);
              let otherInput = this.el.nativeElement.querySelector("#" + item.var + "_other");
              let thisVar = numInput ? numInput.value.trim() : "";
              let ot = otherInput ? otherInput.value.trim() : "";
              if (thisVar == "" && ot == "") {

              } else {
                if (((thisVar == "" && ot != '') || (thisVar != '' && ot == "") || (thisVar != '' && ot != "" && ot.length <= 2)) && item.exclusive == 0) {
                  if (ot == "" || ot.length <= 2) {
                    let hasStringError = false;
                    let hasMediaError = false;
                    for (let err of item.optionText) {
                      if (err.type == "string") {
                        const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                        if (plainText) {
                          hasStringError = true;
                          let strip = this.stripHtml(err.detail);
                          let d1 = strip.trim();
                          if (d1 != "") {
                            error_vars_other.push(d1);
                            errorBlock += d1 + ", ";
                            break;
                          }
                        }
                      }
                      else if (err.type == "image" || err.type == "vedio") {
                        hasMediaError = true;
                      }
                    };
                    if (!hasStringError && hasMediaError) {
                      let d1 = 'Row' + (item.index + 1);
                      if (d1 != "") {
                        error_vars_other.push(d1);
                        errorBlock += d1 + ", ";
                      }
                    }
                  } else {
                    let hasStringError = false;
                    let hasMediaError = false;
                    for (let err of item.optionText) {
                      if (err.type == "string") {
                        const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                        if (plainText) {
                          hasStringError = true;
                          let strip = this.stripHtml(err.detail);
                          let d1 = strip.trim();
                          if (d1 != "") {
                            error_vars.push(d1);
                            errorBlock += d1 + ", ";
                            break;
                          };
                        }
                      }
                      else if (err.type == "image" || err.type == "vedio") {
                        hasMediaError = true;
                      }
                    };
                    if (!hasStringError && hasMediaError) {
                      let d1 = 'Row' + (item.index + 1);
                      if (d1 != "") {
                        error_vars.push(d1);
                        errorBlock += d1 + ", ";
                      }
                    }
                  }
                }
              }

              if (thisVar != "") {
                let sumVal = parseInt(thisVar);
                if (sumVal >= this.numericMin && sumVal <= this.numericMax) {

                } else {
                  perRowError += 1;
                }
              }
            }
          });

          if (error_vars.length != 0 || error_vars_other.length != 0 || perRowError > 0 || othrErr > 0) {
            if (othrErr > 0) {
              errorBlock = error_vars_other.join(", ");
              errorBlock = errorBlock.replace(regex, "");
              this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
            } else {
              if (perRowError > 0) {
                this.error_text_to_print = "Minimum value required for each option is " + this.numericMin + " and maximum value is " + this.numericMax + ".";
              } else {
                if (error_vars.length != 0) {
                  errorBlock = error_vars.join(", ");
                  // errorBlock = errorBlock.replace(regex, "");
                  this.error_text_to_print = "Response is required for " + errorBlock;
                }

                if (error_vars_other.length != 0) {
                  errorBlock = error_vars_other.join(", ");
                  // errorBlock = errorBlock.replace(regex, "");
                  this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";;
                }
              }
            }
          }
          else {
            if (numCheckNot) {
              this.respVar[numCheckNot.value] = 0;
            }
            getAllNum.forEach((allNum, i) => {
              let oth = parseInt(allNum.getAttribute('dataother'));
              let exl = parseInt(allNum.getAttribute('dataexclusive'));
              let valData = 0;
              if (allNum.value != '') {
                valData = parseInt(allNum.value);
              }
              if (oth == 1) {
                let otherEl = this.el.nativeElement.querySelector("#" + allNum.name + "_other");
                let othrVal = otherEl ? otherEl.value.trim() : "";
                this.respVar[allNum.name + "_other"] = othrVal;
                this.respVar[allNum.name] = valData;
              }
              if (exl == 0) {
                this.respVar[allNum.name] = valData;
              }
            });

          }
          // }
        }
      }
    }
    else if (this.surveyDetail.qType == "percentage-row-list") {
      let allValPer = this.el.nativeElement.querySelectorAll(".getAllPerCheck:checked");
      if (allValPer.length > 0) {
        allValPer.forEach(percentage => {
          this.respVar[percentage.value] = 1;
        });
        this.surveyDetail.rowOptionList.forEach(percentage => {
          if (percentage.exclusive == 0) {
            this.respVar[percentage.var] = 0;
          }
          if (percentage.other == 1) {
            this.respVar[percentage.var + "_other"] = "";
          }
        });
      }
      else {
        let regex = /(<([^>]+)>)/ig;
        let error_vars = [];
        let errorBlock = "";
        let perRowError = 0;
        row_arr_no_other.forEach(item => {
          if (item.exclusive == 0) {
            // let thisVar = this.el.nativeElement.querySelector("#" + item.var).value.trim();
            let inputElement = this.el.nativeElement.querySelector("#" + item.var);
            let thisVar = inputElement ? inputElement.value.trim() : "";
            if (thisVar == "") {
              let hasStringError = false;
              let hasMediaError = false;
              for (let err of item.optionText) {
                if (err.type == "string") {
                  const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                  if (plainText) {
                    hasStringError = true;
                    let strip = this.stripHtml(err.detail);
                    let d1 = strip.trim();
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                      break;
                    }
                  }
                }
                else if (err.type == "image" || err.type == "vedio") {
                  hasMediaError = true;
                }
              };
              if (!hasStringError && hasMediaError) {
                let d1 = 'Row' + (item.index + 1);
                if (d1 != "") {
                  error_vars.push(d1);
                  errorBlock += d1 + ", ";
                }
              }
            }
            if (thisVar != "") {
              let sumVal = parseInt(thisVar);
              if (sumVal < this.numericMin || sumVal > this.numericMax) {
                perRowError += 1;
              }
            }
          }
        });

        let error_vars_other = [];
        let othrErr = 0;
        row_arr_other.forEach(item => {
          if (item.other == 1) {
            let valInput = this.el.nativeElement.querySelector("#" + item.var);
            let otInput = this.el.nativeElement.querySelector("#oth_" + item.var);
            let thisVar = valInput ? valInput.value.trim() : "";
            let ot = otInput ? otInput.value.trim() : "";
            if (thisVar == "" && ot == "") {

            } else {
              if (((thisVar == "" && ot != '') || (thisVar != '' && ot == "") || (thisVar != '' && ot != "" && ot.length <= 2)) && item.exclusive == 0) {
                if (ot == "" || ot.length <= 2) {
                  let hasStringError = false;
                  let hasMediaError = false;
                  for (let err of item.optionText) {
                    if (err.type == "string") {
                      const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                      if (plainText) {
                        hasStringError = true;
                        let strip = this.stripHtml(err.detail);
                        let d1 = strip.trim();
                        if (d1 != "") {
                          error_vars_other.push(d1);
                          errorBlock += d1 + ", ";
                          break;
                        }
                      }
                    }
                    else if (err.type == "image" || err.type == "vedio") {
                      hasMediaError = true;
                    }
                  };
                  if (!hasStringError && hasMediaError) {
                    let d1 = 'Row' + (item.index + 1);
                    if (d1 != "") {
                      error_vars_other.push(d1);
                      errorBlock += d1 + ", ";
                    }
                  }
                } else {
                  let hasStringError = false;
                  let hasMediaError = false;
                  for (let err of item.optionText) {
                    if (err.type == "string") {
                      const plainText = err.detail.replace(/<[^>]*>/g, '').trim();
                      if (plainText) {
                        hasStringError = true;
                        let strip = this.stripHtml(err.detail);
                        let d1 = strip.trim();
                        if (d1 != "") {
                          error_vars.push(d1);
                          errorBlock += d1 + ", ";
                          break;
                        }
                      }
                    }
                    else if (err.type == "image" || err.type == "vedio") {
                      hasMediaError = true;
                    }
                  };
                  if (!hasStringError && hasMediaError) {
                    let d1 = 'Row' + (item.index + 1);
                    if (d1 != "") {
                      error_vars.push(d1);
                      errorBlock += d1 + ", ";
                    }
                  }
                }
              }
            }

            if (thisVar != "") {
              let sumVal = parseInt(thisVar);
              if (sumVal < this.numericMin || sumVal > this.numericMax) {
                perRowError += 1;
              }
            }
          }
        });

        if (error_vars.length != 0 || error_vars_other.length != 0 || perRowError > 0) {
          if (othrErr > 0) {
            errorBlock = error_vars_other.join(", ");
            // errorBlock = errorBlock.replace(regex, "");
            this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";
          } else {
            if (perRowError > 0) {
              this.error_text_to_print = "Minimum value required for each option is " + this.numericMin + " and maximum value is " + this.numericMax + ".";
            } else {
              if (error_vars.length != 0) {
                errorBlock = error_vars.join(", ");
                // errorBlock = errorBlock.replace(regex, "");
                this.error_text_to_print = "Response is required for " + errorBlock;
              }

              if (error_vars_other.length != 0) {
                errorBlock = error_vars_other.join(", ");
                // errorBlock = errorBlock.replace(regex, "");
                this.error_text_to_print = "Others response is required for " + errorBlock + " and response should be at least 3 characters";;
              }
            }
          }
        }

        else {
          this.surveyDetail.rowOptionList.forEach(percentage => {
            let percentageInput = this.el.nativeElement.querySelector("#" + percentage.var);
            let othInput = this.el.nativeElement.querySelector("#oth_" + percentage.var);
            if (percentage.other == 1) {
              let percentageNumber = percentageInput ? percentageInput.value : "0";
              let other = othInput ? othInput.value.trim() : "";
              if (percentageNumber == "" || percentageNumber == null) {
                percentageNumber = "0";
              }
              this.respVar[percentage.var] = parseInt(percentageNumber);
              this.respVar[percentage.var + "_other"] = other;
            } else {
              if (percentage.exclusive == 0) {
                let percentageNumber = percentageInput ? percentageInput.value : "0";
                this.respVar[percentage.var] = parseInt(percentageNumber);
              }
              if (percentage.exclusive == 1) {
                this.respVar[percentage.var] = 0;
              }
            }
          });
        }
      }
    }
    else if (this.surveyDetail.qType == "drag-n-drop-ranking-column") {
      // if (this.responseArr.length > 0) {
      if (this.responseArr.length >= this.surveyDetail["MIN-SELECTION"] && this.responseArr.length <= this.surveyDetail["MAX-SELECTION"]) {
        this.responseArr.forEach((rsp, x) => {
          this.respVar[rsp.var] = x + 1;
        });

        if (rowLen > 0) {
          this.surveyDetail.rowOptionList.forEach(rowD => {
            if (this.respVar[rowD.var]) {

            } else {
              this.respVar[rowD.var] = 0;
            }
          });
        }
      }
      else {
        this.error_text_to_print = "Please rank at least " + this.surveyDetail["MIN-SELECTION"] + " items and at most " + this.surveyDetail["MAX-SELECTION"] + " items";
      }
    }
    // else if (this.surveyDetail.qType == "single-select-drop-down") {
    //   // let dropValue = this.el.nativeElement.querySelector("#drop_down_" + this.surveyDetail.var).value;
    //   let dropValue = this.selectedOptionDDSC.optionCode;
    //   if (dropValue != "") {
    //     this.surveyDetail.rowOptionList.forEach(sr => {
    //       if (sr.optionCode == dropValue) {
    //         this.respVar[sr.var] = dropValue;
    //       }
    //     });
    //   }
    //   else {
    //     this.error_text_to_print = "Response is required";
    //   }
    // }
    else if (this.surveyDetail.qType == "single-select-drop-down") {
      let selectedOption = this.selectedOptionDDSCMap[this.surveyDetail.var];
      if (selectedOption && selectedOption.optionCode) {
        this.respVar[selectedOption.var] = selectedOption.optionCode;
      } else {
        this.error_text_to_print = "Response is required";
      }
    }

    else if (this.surveyDetail.qType?.toLowerCase() == "text-highlighter") {

      let isValid = this.validateTextHilighter();
      this.error_text_to_print = isValid?.errorMessege;
      error = isValid?.errorCount;
      this.respVar = isValid?.userResponse;
    } else if (this.surveyDetail.qType == "image-heatmap") {
      let isValid = this.validateImageHeatmap();
      this.error_text_to_print = isValid?.errorMessege;
      error = isValid?.errorCount;
      this.respVar = isValid?.userResponse;
    }
    else if (this.surveyDetail.qType == "max-diff") {
      this.respVar = [];
      let allPresent = true
      this.surveyDetail.attributeSeq.forEach(element => {

        if (allPresent) {
          if (element.values['maxB'] == null || element.values['maxW'] == null) {
            allPresent = false;
            this.respVar = [];
          } else {
            this.respVar = { ...this.respVar, ...{ [this.surveyDetail.qID + '_max' + element.set + '_B']: element.values['maxB'] } }
            this.respVar = { ...this.respVar, ...{ [this.surveyDetail.qID + '_max' + element.set + '_W']: element.values['maxW'] } }
          }
        }
        else {
          this.error_text_to_print = "Response is required";
        }
      });
    }

    if ((Object.keys(this.respVar).length == 0 || (this.openEndLarge == "" && rowLen == 0) || this.inputData == "" || error > 0) && (pass == 0)) {
      if (this.error_text_to_print != "" || this.error_text_to_print != undefined) {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          text: this.error_text_to_print,
        });
        // swal("", this.error_text_to_print, "error");
      }
      else {
        swal({
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
          type: "error",
          title: "Response is required !",
        });
      }
      this.showCard = true;
    }
    else if (pass == 0) {
      this.saveSurveyUrl = this.crurl + this.apiType + '/push/' + this.studyId;
      let headers = new HttpHeaders({ 'Authorization-Parameter': this.cookie });

      this.http.post(this.saveSurveyUrl, {
        "response": this.respVar,
        "pipe-in": this.pipeinvariables
      }, { headers, observe: 'response' }).subscribe(response => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.surveyDetail = response;
        this.arrlength = 0;
        this.videoPlayed = 0;
        this.videoCount = {};
        this.totalVideo = [];
        this.openEndLarge = "No Data";
        this.openEndMedium = "No Data";
        this.inputData = "No Data";
        let data = {};
        data['cookie'] = response.headers.get('User-Validation-Details');
        this.cookie = data['cookie'];
        this.masterData["cookie"] = this.cookie;
        this.setSession(this.masterData);
        this.responseArr = [];
        this.fetchApiCall('');
      },
        (error) => {
          this.showMessage(error);
        });
    }
  }


  onRecordingCompleted(formData) {
    const newFormData = new FormData();
    let fileExtension = '';

    for (const [key, value] of (formData as any).entries()) {
      newFormData.append(key, value);

      // Extract extension from blob if found
      if (value instanceof Blob) {
        const mimeParts = value.type.split('/');
        if (mimeParts.length > 1) {
          fileExtension = mimeParts.pop() || '';
        }
      }
    }

    // Add pipe-in variables
    if (this.pipeinvariables) {
      newFormData.append('pipe-in',
        typeof this.pipeinvariables === 'object'
          ? JSON.stringify(this.pipeinvariables)
          : String(this.pipeinvariables)
      );
      // Add surveyDetail.qID if available
      if (this.surveyDetail?.qID) {
        newFormData.append('qID', this.surveyDetail.qID);
      }
    }

    // Add detected file extension as 'type'
    if (fileExtension) {
      newFormData.append('type', fileExtension);
    }

    this.recordingFormData = newFormData;
    return newFormData;

  }

  ResetOffFn(reseRecording: boolean) {
    this.resetRecordingVar = reseRecording;
  }

  stopRecordFn(stopRecording: boolean) {
    this.stopRecordingVar = stopRecording;

  }

  recorderBlobFn(recordedBlob) {
    this.recorderBlob = recordedBlob

  }

  audioVideoRecorderNext() {
    this.stopRecordingVar = false;
    // if (!this.recordingFormData && (this.setData && this.objectKeys(this.setData).length == 0))
    if (
      (!this.recordingFormData || !this.recorderBlob) &&
      (!this.setData || this.objectKeys(this.setData).length === 0 ||
        Object.values(this.setData).every(val => !val))
    ) {
      swal({
        icon: environment.errorIcon,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "custom-button-color",
            closeModal: true
          },
        },
        type: "error",
        text: "Please complete the recording before proceeding to the next question.",
      });
      return;
    }
    const requestFormData = new FormData();
    if (this.recordingFormData && (this.setData && (this.objectKeys(this.setData).length == 0 ||
      Object.values(this.setData).every(val => !val)))) {

      for (const [key, value] of (this.recordingFormData as any).entries()) {
        requestFormData.append(key, value);
      }


      let headers = new HttpHeaders({
        'Authorization-Parameter': this.cookie,
      });

      this.saveRecordingUrl = this.crurl + this.apiType + '/av_push/' + this.studyId;

      this.http.post(this.saveRecordingUrl, requestFormData, {
        headers,
        observe: 'response'
      }).subscribe((response: any) => {
        this.fetchApiCall('');
      });
    }

    if (!this.recordingFormData && (this.setData && this.objectKeys(this.setData).length != 0)) {
      this.noFormData();
    }
    this.resetRecordingVar = false;
  }


  noFormData() {
    this.saveSurveyUrl = this.crurl + this.apiType + '/push/' + this.studyId;
    let headers = new HttpHeaders({ 'Authorization-Parameter': this.cookie });

    this.http.post(this.saveSurveyUrl, {
      "response": this.setData,
      "pipe-in": this.pipeinvariables
    }, { headers, observe: 'response' }).subscribe(response => {
      this.fetchApiCall('');
    })
  }




  // **============================================== End Save Api ====================================================**
  // **================================================================================================================**


  // **============================================== Call Preious Question===============================================**
  // **===================================================================================================================**

  previousQuestion() {
    this.surveyDetail = '';
    this.showCard = false;
    this.pre = 1;
    this.mainDropArr = [];
    this.responseArr = [];
    this.surveyDetail = {};
    this.fetchApiCall(this.prevQuestion);
  }

  // **============================================== End Preious Question===============================================**
  // **===================================================================================================================**

  // External API call

  callExternal(provider) {
    this.apiUrlProgress = this.crurl + this.apiType + '/external/' + provider + "/" + this.studyId;
    let payload
    if (this.testLink) {
      payload = {
        test: this.testLink,
        "pipe-in": this.pipeinvariables
      }
    }
    else {
      payload = {
        "pipe-in": this.pipeinvariables
      }
    }
    this.http.post(this.apiUrlProgress, payload).subscribe(response => {
      if (response) {
        this.pipeinvariables["ID"] = response["auth"];
        this.masterData['_ctl_ID' + this.finalData["gear"]] = this.pipeinvariables["ID"];
        this.setSession(this.masterData);
        this.initialFnCalls();
      }
    },
      (error) => {
        if (error.status == 500) {
          swal({
            icon: environment.errorIcon,
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "custom-button-color",
                closeModal: true
              },
            },
            type: "error",
            text: "Please try after some time",
            title: "There was a problem processing your request"
          });
        } else {
          if (error.error) {
            if (error.status) {
              swal({
                button: false,
                text: error.error.header.message,
                icon: environment.errorIcon
              });
            }
          }
        }
      });
  }

  showMessage(error) {
    if (error.status == 500) {
      swal({
        button: false,
        text: "Please try after some time",
        icon: environment.errorIcon,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "custom-button-color",
            closeModal: true
          },
        },
        title: "There was a problem processing your request"
      });
    }
    else if (error.status == 400) {
      swal({
        button: false,
        text: error.error.header.message,
        icon: environment.errorIcon,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "custom-button-color",
            closeModal: true
          },
        },
      });
    }

    if (error.error) {
      if (error.error.header.code == 401) {
        if (error.error.header.redirected) {
          if (error.error.header.redirected != '' && error.error.header.redirected.length > 5) {
            window.location.href = error.error.header.redirected;
          }
          else {
            this.showSurvey = false;
            this.showErrorMsg = error.error.header.message;
            this.showError = true;
          }
        }
        else {
          this.showSurvey = false;
          this.showErrorMsg = error.error.header.message;
          this.showError = true;
          swal({
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "custom-button-color",
                closeModal: true
              },
            },
            showCancelButton: false,
            showConfirmButton: false,
            title: error.error.header.message,
          });
          sessionStorage.clear();
        }
      }
      else if (error.error.header.code == 402) {
        if (error.error.header.redirected) {
          if (error.error.header.redirected != '' && error.error.header.redirected.length > 5) {
            window.location.href = error.error.header.redirected;
          }
          else {
            this.showSurvey = false;
            this.showErrorMsg = error.error.header.message;
            this.showError = true;
          }
        }
        else {
          this.showSurvey = false;
          this.showErrorMsg = error.error.header.message;
          this.showError = true;
          swal({
            showCancelButton: false,
            showConfirmButton: false,
            title: error.error.header.message,
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "custom-button-color",
                closeModal: true
              },
            },
          });
          sessionStorage.clear();
        }
      }
      else if (error.error.header.code == 404) {
        swal({
          showCancelButton: false,
          showConfirmButton: false,
          title: error.error.header.message,
        });
      }
      else if (error.error.header.code == 406) {
        this.showCard = true;
        swal({
          button: false,
          text: error.error.header.message,
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
        });
      }
    }
  }

  getSurveyTheme(pre) {
    let sendJson = {};
    this.themeUrl = this.crurl + this.apiType + '/get/surveycolor/' + this.studyId;
    let headers = new HttpHeaders({ 'Authorization-Parameter': this.cookie });
    if (pre != '') {
      sendJson = { "qID": this.prevQuestion, "pipe-in": this.pipeinvariables };
    }
    else {
      sendJson = { "pipe-in": this.pipeinvariables };
    }
    this.http.post(this.themeUrl, sendJson, { headers, observe: 'response' }).subscribe((response: any) => {
      this.background = response.body.data.filter(r => r.name == 'Background Color')[0]?.color;
      document.documentElement.style.setProperty('--background', this.background);
      this.accent = response.body.data.filter(r => r.name == 'Accent Color')[0]?.color;
      document.documentElement.style.setProperty('--accent', this.accent);
      this.font = response.body.data.filter(r => r.name == 'Font Color')[0]?.color;
      document.documentElement.style.setProperty('--font', this.font);
      this.nextButton = response.body.data.filter(r => r.name == 'Next Button Color')[0]?.color;
      document.documentElement.style.setProperty('--nextButton', this.nextButton);
      this.backButton = response.body.data.filter(r => r.name == 'Back Button Color')[0]?.color;
      document.documentElement.style.setProperty('--backButton', this.backButton);
      this.progressBar = response.body.data.filter(r => r.name == 'Progress Bar')[0]?.color;
      document.documentElement.style.setProperty('--progressBar', this.progressBar);
      this.brandLocation = response.body.brandLocation;
      document.documentElement.style.setProperty('--dynamic-button-color', this.nextButton);
      document.documentElement.style.setProperty('--dynamic-button-color', this.nextButton);
    })

  }




  getRowOption(code) {
    return this.surveyDetail.rowOptionList.filter(x => x.optionCode == code)[0]
  }



  nextSet() {
    let currSet = null;
    let currentElement = this.surveyDetail.attributeSeq.find(element => element.set === this.currentSet);

    if (currentElement) {
      // Check if both maxB and maxW are selected
      const missingResponses = [];

      if (!currentElement.values['maxB']) {
        const optionText = this.surveyDetail.colOptionList[0]?.optionText[0]?.detail || 'Option 1';
        missingResponses.push(optionText);
      }

      if (!currentElement.values['maxW']) {
        const optionText = this.surveyDetail.colOptionList[1]?.optionText[0]?.detail || 'Option 2';
        missingResponses.push(optionText);
      }

      if (missingResponses.length > 0) {
        swal({
          text: `Response is required for ${missingResponses.join(' and ')}`,
          icon: environment.errorIcon,
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "custom-button-color",
              closeModal: true
            },
          },
        });
        return;
      }
      //       

      // Proceed to next set
      let index = this.surveyDetail.attributeSeq.indexOf(currentElement);
      if (index < this.surveyDetail.attributeSeq.length - 1) {
        currSet = this.surveyDetail.attributeSeq[index + 1].set;
      } else {
        this.saveSurvey();
        return;
      }
    }

    if (currSet) {
      this.currentSet = currSet;
      setTimeout(() => {
        let element = this.surveyDetail.attributeSeq.find(x => x.set === currSet);
        if (element) {
          element.items.forEach(grid => {
            if (element.values['maxB'] === grid) {
              this.el.nativeElement.querySelector(`#maxdiff_${element.set}_${grid}_0`).click();
            } else if (element.values['maxW'] === grid) {
              this.el.nativeElement.querySelector(`#maxdiff_${element.set}_${grid}_1`).click();
            }
          });
        }
      }, 100);
    }
  }


  previousSet() {
    let currSet = 0;
    this.surveyDetail.attributeSeq.forEach((element, i) => {
      if (element.set == this.currentSet) {
        if (i > 0) {
          currSet = this.surveyDetail.attributeSeq[i - 1].set;
        }
        if (i == 0) {
          this.previousQuestion();
        }
      }
    });
    this.currentSet = currSet;
  }

  openImagePopup(image: any) {
    this.selectedImage = image; // Set the selected image
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }



  // toggleDropdown() {
  //   this.isDropdownOpen = !this.isDropdownOpen;
  // }

  // selectOption(option: any) {
  //   this.selectedOptionDDSC = option;
  //   this.isDropdownOpen = false;
  // }

  toggleDropdown(varName: string) {
    this.isDropdownOpenMap[varName] = !this.isDropdownOpenMap[varName];
  }

  selectOption(option: any, varName: string) {
    this.selectedOptionDDSCMap[varName] = option;
    this.isDropdownOpenMap[varName] = false;
  }

  getOptionHTML(option: any): string {
    const htmlParts = option.optionText
      .filter((ql: any) => ql.type === 'string')
      .map((ql: any) => ql.detail);
    return htmlParts.join(' ');
  }

  getMergedFloatingStyle(): any {
    return {
      ...this.floatingHeaderStyle,
      // ...this.responsiveWidthGrid()
    };
  }
  // ################################# text-highlighter start #####################################
  makeTextHighlighter() {
    this.surveyDetail["isSentimentOpen"] = false;
    this.surveyDetail["isHighlight"] = 0;
    // this.surveyDetail.rowOptionList = [
    //   {
    //     "exclusive": 0,
    //     "id": "CQ4-r1",
    //     "optionCode": 1,
    //     "optionLogic": "#36A824",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Like",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ4",
    //     "seq": 1,
    //     "sno": 245,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ4_1"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ4-r2",
    //     "optionCode": 2,
    //     "optionLogic": "#C6254C",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Dislike",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ4",
    //     "seq": 2,
    //     "sno": 246,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ4_2"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ4-r3",
    //     "optionCode": 3,
    //     "optionLogic": "#DB9406",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Somewhat",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ4",
    //     "seq": 3,
    //     "sno": 247,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ4_3"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ4-r4",
    //     "optionCode": 4,
    //     "optionLogic": "#8451EC",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Most Liked",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ4",
    //     "seq": 4,
    //     "sno": 248,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ4_4"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ4-r5",
    //     "optionCode": 5,
    //     "optionLogic": "#2874C1",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Disappointing",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ4",
    //     "seq": 5,
    //     "sno": 249,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ4_5"
    //   }
    // ]
    this.surveyDetail?.rowOptionList.forEach(row => {
      if (row?.optionLogic.includes("#") == false) {
        row.optionLogic = "#" + row.optionLogic;
      };
    });
    this.surveyDetail["selectedSentiment"] = this.surveyDetail?.rowOptionList[0]?.optionLogic;
    this.surveyDetail["selectedSentimentMobile"] = this.surveyDetail?.rowOptionList[0];

    this.surveyDetail["paragraph"] = this.surveyDetail?.text_tokens.map((line, lineIndex) =>
      line.map((word, wordIndex) => ({
        id: "word__" + lineIndex + "_" + wordIndex,
        text: word,
        sentiment: ""
      }))
    );
  };

  // text-highlighter and image-heatmap
  selectSentiment(sentiment) {
    this.surveyDetail["selectedSentiment"] = sentiment?.optionLogic || "";
    this.surveyDetail["selectedSentimentMobile"] = sentiment;
  };

  toggleWord(word, event?: MouseEvent) {
    if (!this.surveyDetail?.selectedSentiment) return;
    if (event) event.stopPropagation();

    if (word.sentiment == this.surveyDetail?.selectedSentiment) {
      word.sentiment = "";
    } else {
      word.sentiment = this.surveyDetail?.selectedSentiment;
    };

    this.isHighlight();
    this.surveyDetail["isSentimentOpen"] = false;
  };

  isHighlight() {
    this.surveyDetail["isHighlight"] = 0;
    if (this.surveyDetail?.paragraph?.length > 0) {
      this.surveyDetail?.paragraph?.forEach(para => {
        if (para?.length > 0) {
          para.forEach(word => {
            if (word?.sentiment != undefined && word?.sentiment != "") {
              this.surveyDetail.isHighlight = 1;
            };
          });
        };
      });
    };
  };

  highlightSelection() {
    let selection = window.getSelection();
    if (!selection || selection.isCollapsed) return;

    let container = this.el.nativeElement.querySelector('.highlight-text');
    let spans = Array.from(container.querySelectorAll('.word')) as HTMLElement[];

    let selectedIds: string[] = [];
    spans.forEach(span => {
      if (selection.containsNode(span, true)) {
        let id = span.getAttribute("id");
        if (id) selectedIds.push(id);
      };
    });

    let selectedIdSet = new Set(selectedIds);
    this.surveyDetail.paragraph = this.surveyDetail.paragraph.map(line =>
      line.map(obj => {
        if (selectedIdSet.has(obj.id)) {
          return {
            ...obj,
            sentiment: obj.sentiment === this.surveyDetail.selectedSentiment ? "" : this.surveyDetail.selectedSentiment
          };
        }
        return obj;
      })
    );
    this.isHighlight();
    selection.removeAllRanges();
  };

  clearHighlights() {
    this.surveyDetail.paragraph.forEach(para => {
      para.forEach(word => word.sentiment = "");
    });
    this.surveyDetail.isHighlight = 0;
  };

  validateTextHilighter() {
    let result = {
      errorCount: 0,
      errorMessege: "",
      userResponse: {}
    };

    let notSelected = 0;
    let totalwords = 0;
    this.surveyDetail.paragraph.forEach(para => {
      let item = para.filter(obj => obj.sentiment == "");
      notSelected = notSelected + item.length;
      totalwords = totalwords + para.length;
    });

    if (notSelected == totalwords) {
      result.errorCount++;
      result.errorMessege = "Response is required.";
    };

    if (result.errorCount == 0) {
      let selected = 0;
      this.surveyDetail.paragraph.forEach(para => {
        let item = para.filter(obj => obj.sentiment != "");
        selected = selected + item.length;
      });
      if (selected < this.surveyDetail["MIN-SELECTION"]) {
        result.errorCount++;
        result.errorMessege = "A minimum of " + this.surveyDetail["MIN-SELECTION"] + " words must be highlighted.";
      };
    };

    if (result.errorCount == 0) {
      let selected = 0;
      this.surveyDetail.paragraph.forEach(para => {
        let item = para.filter(obj => obj.sentiment != "");
        selected = selected + item.length;
      });
      if (selected > this.surveyDetail["MAX-SELECTION"]) {
        result.errorCount++;
        result.errorMessege = "You can highlight up to " + this.surveyDetail["MAX-SELECTION"] + " words. To select a new one, click an already highlighted word to deselect it first.";
      };
    };

    if (result.errorCount == 0) {
      result.userResponse = {};
      this.surveyDetail.rowOptionList.forEach(row => {
        let selected = [];
        this.surveyDetail.paragraph.forEach(para => {
          let item = para.filter(obj => obj.sentiment == row.optionLogic);
          selected.push(...item);
        });

        let finalData = selected.map(word => {
          let parts = word.id.split('__')[1].split('_');
          return [Number(parts[0]), Number(parts[1])];
        });
        result.userResponse[row.var] = finalData;
      });
    };

    return result;
  };

  setTextHighlighter(response) {
    if (Object.keys(response).length > 0) {
      Object.keys(response).forEach(key => {
        if (response[key].length > 0) {
          let option = this.surveyDetail.rowOptionList.find(row => row.var == key);
          if (option != undefined) {
            response[key].forEach(item => {
              if (item.length == 2) {
                this.surveyDetail.paragraph[item[0]][item[1]].sentiment = option?.optionLogic || "";
              };
            });
          };
        };
      });
      this.isHighlight();
    };
  };

  // text-highlighter and image-heatmap
  sentimentDropdown() {
    this.surveyDetail.isSentimentOpen = !this.surveyDetail.isSentimentOpen;
  };
  // ################################# text-highlighter end #######################################


  // ################################# image-heatmap start #####################################
  makeImageHeatmap() {
    this.surveyDetail["isSentimentOpen"] = false;
    this.surveyDetail["isMarked"] = 0;
    // this.surveyDetail.rowOptionList = [
    //   {
    //     "exclusive": 0,
    //     "id": "CQ3-r1",
    //     "optionCode": 1,
    //     "optionLogic": "#36A824",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Like",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ3",
    //     "seq": 1,
    //     "sno": 258,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ3_1"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ3-r2",
    //     "optionCode": 2,
    //     "optionLogic": "#C6254C",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Dislike",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ3",
    //     "seq": 2,
    //     "sno": 259,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ3_2"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ3-r3",
    //     "optionCode": 3,
    //     "optionLogic": "#DB9406",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Somewhat",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ3",
    //     "seq": 3,
    //     "sno": 260,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ3_3"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ3-r4",
    //     "optionCode": 4,
    //     "optionLogic": "#8451EC",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Most Liked",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ3",
    //     "seq": 4,
    //     "sno": 261,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ3_4"
    //   },
    //   {
    //     "exclusive": 0,
    //     "id": "CQ3-r5",
    //     "optionCode": 5,
    //     "optionLogic": "#2874C1",
    //     "optionNote": "\"\"",
    //     "optionOther": 0,
    //     "optionText": "Disappointing",
    //     "optionText_esp": "",
    //     "optionType": "image-heatmap",
    //     "qID": "CQ3",
    //     "seq": 5,
    //     "sno": 262,
    //     "tier1": 0,
    //     "tier2": 0,
    //     "tier3": 0,
    //     "var": "CQ3_5"
    //   }
    // ]
    this.surveyDetail?.rowOptionList.forEach(row => {
      if (row?.optionLogic.includes("#") == false) {
        row.optionLogic = "#" + row.optionLogic;
      };
    });
    this.surveyDetail["selectedSentiment"] = this.surveyDetail?.rowOptionList[0]?.optionLogic;
    this.surveyDetail["selectedSentimentMobile"] = this.surveyDetail?.rowOptionList[0];
    this.surveyDetail["clickPoint"] = [];
  };

  isHeatmapMarked() {
    if (this.surveyDetail?.clickPoint?.length >= this.surveyDetail?.["MIN-SELECTION"]) {
      this.surveyDetail["isMarked"] = this.surveyDetail?.clickPoint?.length;
    } else {
      this.surveyDetail["isMarked"] = 0;
    };
  };

  markImageHeatmap(event: MouseEvent) {
    let img = event.target as HTMLImageElement;
    let rect = img.getBoundingClientRect();

    let xPercent = ((event.clientX - rect.left) / rect.width) * 100;
    let yPercent = ((event.clientY - rect.top) / rect.height) * 100;

    let point = {
      "xPercent": xPercent,
      "yPercent": yPercent,
      "sentiment": this.surveyDetail?.selectedSentiment || ""
    };
    this.surveyDetail?.clickPoint.push(point);
    this.isHeatmapMarked();
  }

  removeHeatmapPoint(point) {
    if (this.surveyDetail?.selectedSentiment == point?.sentiment) {
      this.surveyDetail.clickPoint = this.surveyDetail?.clickPoint.filter(obj => !(obj.xPercent == point.xPercent && obj.yPercent == point.yPercent));
    } else {
      point.sentiment = this.surveyDetail?.selectedSentiment;
    };
    this.isHeatmapMarked();
  };

  clearHeatmapMakrker() {
    this.surveyDetail.clickPoint = [];
    this.isHeatmapMarked();
  };

  validateImageHeatmap() {
    let result = {
      errorCount: 0,
      errorMessege: "",
      userResponse: {}
    };

    if (this.surveyDetail?.clickPoint?.length == 0) {
      result.errorCount++;
      result.errorMessege = "Response is required.";
    };

    if (result.errorCount == 0 && this.surveyDetail?.clickPoint?.length < this.surveyDetail["MIN-SELECTION"]) {
      result.errorCount++;
      result.errorMessege = "A minimum of " + this.surveyDetail["MIN-SELECTION"] + " markers must be placed.";
    };

    if (result.errorCount == 0 && this.surveyDetail?.clickPoint?.length > this.surveyDetail["MAX-SELECTION"]) {
      result.errorCount++;
      result.errorMessege = "A maximum of " + this.surveyDetail["MAX-SELECTION"] + " markers can be placed. Remove individual markers by clicking them again.";
    };

    if (result.errorCount == 0) {
      result.userResponse = {};
      this.surveyDetail.rowOptionList.forEach(row => {
        let finalData = [];
        let data = this.surveyDetail?.clickPoint.filter(obj => obj?.sentiment == row?.optionLogic);
        if (data.length > 0) {
          data.forEach(obj => {
            let point = {
              "xPercent": obj?.xPercent,
              "yPercent": obj?.yPercent
            };
            finalData.push(point);
          });
        };
        result.userResponse[row.var] = finalData;
      });
    };
    return result;
  };

  setImageHeatmap(response) {
    if (Object.keys(response).length > 0) {
      Object.keys(response).forEach(key => {
        if (response[key].length > 0) {
          let option = this.surveyDetail.rowOptionList.find(row => row.var == key);
          if (option != undefined) {
            response[key].forEach(item => {
              let point = {
                "xPercent": item?.xPercent,
                "yPercent": item?.yPercent,
                "sentiment": option?.optionLogic || ""
              };
              this.surveyDetail.clickPoint.push(point);
            });
          };
        };
      });
    };
    this.isHeatmapMarked();
  };

  // ################################# image-heatmap end #######################################

}



















